/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MainRouteRouteImport } from './routes/_main/route'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as rootIndexRouteImport } from './routes/(root)/index'
import { Route as MainSwitchUserRouteImport } from './routes/_main/switch-user'
import { Route as MainUserRouteRouteImport } from './routes/_main/user/route'
import { Route as MainAdminRouteRouteImport } from './routes/_main/admin/route'
import { Route as AuthSignUpRouteRouteImport } from './routes/_auth/sign-up/route'
import { Route as AuthSignInRouteRouteImport } from './routes/_auth/sign-in/route'
import { Route as AuthFindPasswordRouteRouteImport } from './routes/_auth/find-password/route'
import { Route as MainUserIndexRouteImport } from './routes/_main/user/index'
import { Route as MainAdminIndexRouteImport } from './routes/_main/admin/index'
import { Route as AuthSignInIndexRouteImport } from './routes/_auth/sign-in/index'
import { Route as AuthSignUpSmsRouteImport } from './routes/_auth/sign-up/sms'
import { Route as AuthSignUpMailRouteImport } from './routes/_auth/sign-up/mail'
import { Route as AuthSignInSmsRouteImport } from './routes/_auth/sign-in/sms'
import { Route as AuthSignInMfaRouteImport } from './routes/_auth/sign-in/mfa'
import { Route as AuthSignInMailRouteImport } from './routes/_auth/sign-in/mail'
import { Route as AuthSignInAppRouteImport } from './routes/_auth/sign-in/app'
import { Route as AuthFindPasswordSmsRouteImport } from './routes/_auth/find-password/sms'
import { Route as AuthFindPasswordMailRouteImport } from './routes/_auth/find-password/mail'
import { Route as AuthOauthOauthQrcodeRouteImport } from './routes/_auth/_oauth/oauth-qrcode'
import { Route as AuthOauthOauthRouteImport } from './routes/_auth/_oauth/oauth'
import { Route as MainUserAccountRouteRouteImport } from './routes/_main/user/account/route'
import { Route as MainAdminUserRouteRouteImport } from './routes/_main/admin/user/route'
import { Route as MainAdminSmsRouteRouteImport } from './routes/_main/admin/sms/route'
import { Route as MainAdminRbacRouteRouteImport } from './routes/_main/admin/rbac/route'
import { Route as MainAdminFileRouteRouteImport } from './routes/_main/admin/file/route'
import { Route as MainAdminEmailRouteRouteImport } from './routes/_main/admin/email/route'
import { Route as MainAdminConfigRouteRouteImport } from './routes/_main/admin/config/route'
import { Route as MainAdminAppRouteRouteImport } from './routes/_main/admin/app/route'
import { Route as MainAdminConfigIndexRouteImport } from './routes/_main/admin/config/index'
import { Route as MainUserAccountSetNameRouteImport } from './routes/_main/user/account/set-name'
import { Route as MainUserAccountSetInfoRouteImport } from './routes/_main/user/account/set-info'
import { Route as MainUserAccountMobileRouteImport } from './routes/_main/user/account/mobile'
import { Route as MainUserAccountMfaRouteImport } from './routes/_main/user/account/mfa'
import { Route as MainUserAccountLoginLogRouteImport } from './routes/_main/user/account/login-log'
import { Route as MainUserAccountFileRouteImport } from './routes/_main/user/account/file'
import { Route as MainUserAccountExternalRouteImport } from './routes/_main/user/account/external'
import { Route as MainUserAccountEmailRouteImport } from './routes/_main/user/account/email'
import { Route as MainUserAccountChangePasswordRouteImport } from './routes/_main/user/account/change-password'
import { Route as MainUserAccountAddressRouteImport } from './routes/_main/user/account/address'
import { Route as MainAdminUserSearchRouteImport } from './routes/_main/admin/user/search'
import { Route as MainAdminUserLoginLogRouteImport } from './routes/_main/admin/user/login-log'
import { Route as MainAdminUserChangeLogRouteImport } from './routes/_main/admin/user/change-log'
import { Route as MainAdminSmsSendLogRouteImport } from './routes/_main/admin/sms/send-log'
import { Route as MainAdminSmsAdapterConfigRouteImport } from './routes/_main/admin/sms/adapter-config'
import { Route as MainAdminRbacRoleRouteImport } from './routes/_main/admin/rbac/role'
import { Route as MainAdminRbacResourceRouteImport } from './routes/_main/admin/rbac/resource'
import { Route as MainAdminRbacAuditLogRouteImport } from './routes/_main/admin/rbac/audit-log'
import { Route as MainAdminFileRuntimeSettingRouteImport } from './routes/_main/admin/file/runtime-setting'
import { Route as MainAdminFileOssConfigRouteImport } from './routes/_main/admin/file/oss-config'
import { Route as MainAdminFileListRouteImport } from './routes/_main/admin/file/list'
import { Route as MainAdminEmailSendLogRouteImport } from './routes/_main/admin/email/send-log'
import { Route as MainAdminEmailAdapterConfigRouteImport } from './routes/_main/admin/email/adapter-config'
import { Route as MainAdminAppRequestRouteImport } from './routes/_main/admin/app/request'
import { Route as MainAdminAppListRouteImport } from './routes/_main/admin/app/list'
import { Route as MainUserAppRootRouteRouteImport } from './routes/_main/user/app/_root/route'
import { Route as MainUserAppAppIdRouteRouteImport } from './routes/_main/user/app/$appId/route'
import { Route as MainUserAppAppIdIndexRouteImport } from './routes/_main/user/app/$appId/index'
import { Route as MainUserAppRootListRouteImport } from './routes/_main/user/app/_root/list'
import { Route as MainUserAppRootDashboardRouteImport } from './routes/_main/user/app/_root/dashboard'
import { Route as MainUserAppRootCreateRouteImport } from './routes/_main/user/app/_root/create'
import { Route as MainUserAppAppIdSettingRouteImport } from './routes/_main/user/app/$appId/setting'
import { Route as MainUserAppAppIdRequestPromptRouteImport } from './routes/_main/user/app/$appId/request-prompt'
import { Route as MainUserAppAppIdRequestRouteImport } from './routes/_main/user/app/$appId/request'
import { Route as MainUserAppAppIdNotifyRouteImport } from './routes/_main/user/app/$appId/notify'
import { Route as MainAdminSmsSendConfigRuleRouteImport } from './routes/_main/admin/sms/send-config/rule'
import { Route as MainAdminSmsSendConfigChannelRouteImport } from './routes/_main/admin/sms/send-config/channel'
import { Route as MainAdminEmailSendConfigTemplateRouteImport } from './routes/_main/admin/email/send-config/template'
import { Route as MainAdminEmailSendConfigRuleRouteImport } from './routes/_main/admin/email/send-config/rule'
import { Route as MainAdminEmailSendConfigChannelRouteImport } from './routes/_main/admin/email/send-config/channel'
import { Route as MainUserAppAppIdSubAppRequestRouteImport } from './routes/_main/user/app/$appId/sub-app/request'
import { Route as MainUserAppAppIdSubAppListRouteImport } from './routes/_main/user/app/$appId/sub-app/list'
import { Route as MainUserAppAppIdServiceSubAppOauthServerRouteImport } from './routes/_main/user/app/$appId/service/sub-app-oauth-server'
import { Route as MainUserAppAppIdServiceSubAppRouteImport } from './routes/_main/user/app/$appId/service/sub-app'
import { Route as MainUserAppAppIdServiceOauthClientRouteImport } from './routes/_main/user/app/$appId/service/oauth-client'
import { Route as MainUserAppAppIdServiceFeatureRouteImport } from './routes/_main/user/app/$appId/service/feature'
import { Route as MainUserAppAppIdServiceExterLoginRouteImport } from './routes/_main/user/app/$appId/service/exter-login'
import { Route as MainUserAppAppIdFeaturesSmsTplConfigRouteImport } from './routes/_main/user/app/$appId/features-sms/tpl-config'
import { Route as MainUserAppAppIdFeaturesSmsSendRouteImport } from './routes/_main/user/app/$appId/features-sms/send'
import { Route as MainUserAppAppIdFeaturesSmsListRouteImport } from './routes/_main/user/app/$appId/features-sms/list'
import { Route as MainUserAppAppIdFeaturesSmsConfigRouteImport } from './routes/_main/user/app/$appId/features-sms/config'
import { Route as MainUserAppAppIdFeaturesRbacRoleRouteImport } from './routes/_main/user/app/$appId/features-rbac/role'
import { Route as MainUserAppAppIdFeaturesRbacResourceRouteImport } from './routes/_main/user/app/$appId/features-rbac/resource'
import { Route as MainUserAppAppIdFeaturesRbacAuditRouteImport } from './routes/_main/user/app/$appId/features-rbac/audit'
import { Route as MainUserAppAppIdFeaturesMailTplConfigRouteImport } from './routes/_main/user/app/$appId/features-mail/tpl-config'
import { Route as MainUserAppAppIdFeaturesMailTplRouteImport } from './routes/_main/user/app/$appId/features-mail/tpl'
import { Route as MainUserAppAppIdFeaturesMailSendRouteImport } from './routes/_main/user/app/$appId/features-mail/send'
import { Route as MainUserAppAppIdFeaturesMailListRouteImport } from './routes/_main/user/app/$appId/features-mail/list'
import { Route as MainUserAppAppIdFeaturesMailConfigRouteImport } from './routes/_main/user/app/$appId/features-mail/config'
import { Route as MainUserAppAppIdFeaturesFileListRouteImport } from './routes/_main/user/app/$appId/features-file/list'
import { Route as MainUserAppAppIdFeaturesFileCollectorRouteImport } from './routes/_main/user/app/$appId/features-file/collector'
import { Route as MainUserAppAppIdFeaturesBarcodeListParseRouteImport } from './routes/_main/user/app/$appId/features-barcode/list-parse'
import { Route as MainUserAppAppIdFeaturesBarcodeListCreateRouteImport } from './routes/_main/user/app/$appId/features-barcode/list-create'

const MainRouteRoute = MainRouteRouteImport.update({
  id: '/_main',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const rootIndexRoute = rootIndexRouteImport.update({
  id: '/(root)/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const MainSwitchUserRoute = MainSwitchUserRouteImport.update({
  id: '/switch-user',
  path: '/switch-user',
  getParentRoute: () => MainRouteRoute,
} as any)
const MainUserRouteRoute = MainUserRouteRouteImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => MainRouteRoute,
} as any)
const MainAdminRouteRoute = MainAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => MainRouteRoute,
} as any)
const AuthSignUpRouteRoute = AuthSignUpRouteRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSignInRouteRoute = AuthSignInRouteRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthFindPasswordRouteRoute = AuthFindPasswordRouteRouteImport.update({
  id: '/find-password',
  path: '/find-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const MainUserIndexRoute = MainUserIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainUserRouteRoute,
} as any)
const MainAdminIndexRoute = MainAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainAdminRouteRoute,
} as any)
const AuthSignInIndexRoute = AuthSignInIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthSignInRouteRoute,
} as any)
const AuthSignUpSmsRoute = AuthSignUpSmsRouteImport.update({
  id: '/sms',
  path: '/sms',
  getParentRoute: () => AuthSignUpRouteRoute,
} as any)
const AuthSignUpMailRoute = AuthSignUpMailRouteImport.update({
  id: '/mail',
  path: '/mail',
  getParentRoute: () => AuthSignUpRouteRoute,
} as any)
const AuthSignInSmsRoute = AuthSignInSmsRouteImport.update({
  id: '/sms',
  path: '/sms',
  getParentRoute: () => AuthSignInRouteRoute,
} as any)
const AuthSignInMfaRoute = AuthSignInMfaRouteImport.update({
  id: '/mfa',
  path: '/mfa',
  getParentRoute: () => AuthSignInRouteRoute,
} as any)
const AuthSignInMailRoute = AuthSignInMailRouteImport.update({
  id: '/mail',
  path: '/mail',
  getParentRoute: () => AuthSignInRouteRoute,
} as any)
const AuthSignInAppRoute = AuthSignInAppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => AuthSignInRouteRoute,
} as any)
const AuthFindPasswordSmsRoute = AuthFindPasswordSmsRouteImport.update({
  id: '/sms',
  path: '/sms',
  getParentRoute: () => AuthFindPasswordRouteRoute,
} as any)
const AuthFindPasswordMailRoute = AuthFindPasswordMailRouteImport.update({
  id: '/mail',
  path: '/mail',
  getParentRoute: () => AuthFindPasswordRouteRoute,
} as any)
const AuthOauthOauthQrcodeRoute = AuthOauthOauthQrcodeRouteImport.update({
  id: '/_oauth/oauth-qrcode',
  path: '/oauth-qrcode',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthOauthOauthRoute = AuthOauthOauthRouteImport.update({
  id: '/_oauth/oauth',
  path: '/oauth',
  getParentRoute: () => AuthRouteRoute,
} as any)
const MainUserAccountRouteRoute = MainUserAccountRouteRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => MainUserRouteRoute,
} as any)
const MainAdminUserRouteRoute = MainAdminUserRouteRouteImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => MainAdminRouteRoute,
} as any)
const MainAdminSmsRouteRoute = MainAdminSmsRouteRouteImport.update({
  id: '/sms',
  path: '/sms',
  getParentRoute: () => MainAdminRouteRoute,
} as any)
const MainAdminRbacRouteRoute = MainAdminRbacRouteRouteImport.update({
  id: '/rbac',
  path: '/rbac',
  getParentRoute: () => MainAdminRouteRoute,
} as any)
const MainAdminFileRouteRoute = MainAdminFileRouteRouteImport.update({
  id: '/file',
  path: '/file',
  getParentRoute: () => MainAdminRouteRoute,
} as any)
const MainAdminEmailRouteRoute = MainAdminEmailRouteRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => MainAdminRouteRoute,
} as any)
const MainAdminConfigRouteRoute = MainAdminConfigRouteRouteImport.update({
  id: '/config',
  path: '/config',
  getParentRoute: () => MainAdminRouteRoute,
} as any)
const MainAdminAppRouteRoute = MainAdminAppRouteRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => MainAdminRouteRoute,
} as any)
const MainAdminConfigIndexRoute = MainAdminConfigIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainAdminConfigRouteRoute,
} as any)
const MainUserAccountSetNameRoute = MainUserAccountSetNameRouteImport.update({
  id: '/set-name',
  path: '/set-name',
  getParentRoute: () => MainUserAccountRouteRoute,
} as any)
const MainUserAccountSetInfoRoute = MainUserAccountSetInfoRouteImport.update({
  id: '/set-info',
  path: '/set-info',
  getParentRoute: () => MainUserAccountRouteRoute,
} as any)
const MainUserAccountMobileRoute = MainUserAccountMobileRouteImport.update({
  id: '/mobile',
  path: '/mobile',
  getParentRoute: () => MainUserAccountRouteRoute,
} as any)
const MainUserAccountMfaRoute = MainUserAccountMfaRouteImport.update({
  id: '/mfa',
  path: '/mfa',
  getParentRoute: () => MainUserAccountRouteRoute,
} as any)
const MainUserAccountLoginLogRoute = MainUserAccountLoginLogRouteImport.update({
  id: '/login-log',
  path: '/login-log',
  getParentRoute: () => MainUserAccountRouteRoute,
} as any)
const MainUserAccountFileRoute = MainUserAccountFileRouteImport.update({
  id: '/file',
  path: '/file',
  getParentRoute: () => MainUserAccountRouteRoute,
} as any)
const MainUserAccountExternalRoute = MainUserAccountExternalRouteImport.update({
  id: '/external',
  path: '/external',
  getParentRoute: () => MainUserAccountRouteRoute,
} as any)
const MainUserAccountEmailRoute = MainUserAccountEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => MainUserAccountRouteRoute,
} as any)
const MainUserAccountChangePasswordRoute =
  MainUserAccountChangePasswordRouteImport.update({
    id: '/change-password',
    path: '/change-password',
    getParentRoute: () => MainUserAccountRouteRoute,
  } as any)
const MainUserAccountAddressRoute = MainUserAccountAddressRouteImport.update({
  id: '/address',
  path: '/address',
  getParentRoute: () => MainUserAccountRouteRoute,
} as any)
const MainAdminUserSearchRoute = MainAdminUserSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => MainAdminUserRouteRoute,
} as any)
const MainAdminUserLoginLogRoute = MainAdminUserLoginLogRouteImport.update({
  id: '/login-log',
  path: '/login-log',
  getParentRoute: () => MainAdminUserRouteRoute,
} as any)
const MainAdminUserChangeLogRoute = MainAdminUserChangeLogRouteImport.update({
  id: '/change-log',
  path: '/change-log',
  getParentRoute: () => MainAdminUserRouteRoute,
} as any)
const MainAdminSmsSendLogRoute = MainAdminSmsSendLogRouteImport.update({
  id: '/send-log',
  path: '/send-log',
  getParentRoute: () => MainAdminSmsRouteRoute,
} as any)
const MainAdminSmsAdapterConfigRoute =
  MainAdminSmsAdapterConfigRouteImport.update({
    id: '/adapter-config',
    path: '/adapter-config',
    getParentRoute: () => MainAdminSmsRouteRoute,
  } as any)
const MainAdminRbacRoleRoute = MainAdminRbacRoleRouteImport.update({
  id: '/role',
  path: '/role',
  getParentRoute: () => MainAdminRbacRouteRoute,
} as any)
const MainAdminRbacResourceRoute = MainAdminRbacResourceRouteImport.update({
  id: '/resource',
  path: '/resource',
  getParentRoute: () => MainAdminRbacRouteRoute,
} as any)
const MainAdminRbacAuditLogRoute = MainAdminRbacAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => MainAdminRbacRouteRoute,
} as any)
const MainAdminFileRuntimeSettingRoute =
  MainAdminFileRuntimeSettingRouteImport.update({
    id: '/runtime-setting',
    path: '/runtime-setting',
    getParentRoute: () => MainAdminFileRouteRoute,
  } as any)
const MainAdminFileOssConfigRoute = MainAdminFileOssConfigRouteImport.update({
  id: '/oss-config',
  path: '/oss-config',
  getParentRoute: () => MainAdminFileRouteRoute,
} as any)
const MainAdminFileListRoute = MainAdminFileListRouteImport.update({
  id: '/list',
  path: '/list',
  getParentRoute: () => MainAdminFileRouteRoute,
} as any)
const MainAdminEmailSendLogRoute = MainAdminEmailSendLogRouteImport.update({
  id: '/send-log',
  path: '/send-log',
  getParentRoute: () => MainAdminEmailRouteRoute,
} as any)
const MainAdminEmailAdapterConfigRoute =
  MainAdminEmailAdapterConfigRouteImport.update({
    id: '/adapter-config',
    path: '/adapter-config',
    getParentRoute: () => MainAdminEmailRouteRoute,
  } as any)
const MainAdminAppRequestRoute = MainAdminAppRequestRouteImport.update({
  id: '/request',
  path: '/request',
  getParentRoute: () => MainAdminAppRouteRoute,
} as any)
const MainAdminAppListRoute = MainAdminAppListRouteImport.update({
  id: '/list',
  path: '/list',
  getParentRoute: () => MainAdminAppRouteRoute,
} as any)
const MainUserAppRootRouteRoute = MainUserAppRootRouteRouteImport.update({
  id: '/app/_root',
  path: '/app',
  getParentRoute: () => MainUserRouteRoute,
} as any)
const MainUserAppAppIdRouteRoute = MainUserAppAppIdRouteRouteImport.update({
  id: '/app/$appId',
  path: '/app/$appId',
  getParentRoute: () => MainUserRouteRoute,
} as any)
const MainUserAppAppIdIndexRoute = MainUserAppAppIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainUserAppAppIdRouteRoute,
} as any)
const MainUserAppRootListRoute = MainUserAppRootListRouteImport.update({
  id: '/list',
  path: '/list',
  getParentRoute: () => MainUserAppRootRouteRoute,
} as any)
const MainUserAppRootDashboardRoute =
  MainUserAppRootDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => MainUserAppRootRouteRoute,
  } as any)
const MainUserAppRootCreateRoute = MainUserAppRootCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => MainUserAppRootRouteRoute,
} as any)
const MainUserAppAppIdSettingRoute = MainUserAppAppIdSettingRouteImport.update({
  id: '/setting',
  path: '/setting',
  getParentRoute: () => MainUserAppAppIdRouteRoute,
} as any)
const MainUserAppAppIdRequestPromptRoute =
  MainUserAppAppIdRequestPromptRouteImport.update({
    id: '/request-prompt',
    path: '/request-prompt',
    getParentRoute: () => MainUserAppAppIdRouteRoute,
  } as any)
const MainUserAppAppIdRequestRoute = MainUserAppAppIdRequestRouteImport.update({
  id: '/request',
  path: '/request',
  getParentRoute: () => MainUserAppAppIdRouteRoute,
} as any)
const MainUserAppAppIdNotifyRoute = MainUserAppAppIdNotifyRouteImport.update({
  id: '/notify',
  path: '/notify',
  getParentRoute: () => MainUserAppAppIdRouteRoute,
} as any)
const MainAdminSmsSendConfigRuleRoute =
  MainAdminSmsSendConfigRuleRouteImport.update({
    id: '/send-config/rule',
    path: '/send-config/rule',
    getParentRoute: () => MainAdminSmsRouteRoute,
  } as any)
const MainAdminSmsSendConfigChannelRoute =
  MainAdminSmsSendConfigChannelRouteImport.update({
    id: '/send-config/channel',
    path: '/send-config/channel',
    getParentRoute: () => MainAdminSmsRouteRoute,
  } as any)
const MainAdminEmailSendConfigTemplateRoute =
  MainAdminEmailSendConfigTemplateRouteImport.update({
    id: '/send-config/template',
    path: '/send-config/template',
    getParentRoute: () => MainAdminEmailRouteRoute,
  } as any)
const MainAdminEmailSendConfigRuleRoute =
  MainAdminEmailSendConfigRuleRouteImport.update({
    id: '/send-config/rule',
    path: '/send-config/rule',
    getParentRoute: () => MainAdminEmailRouteRoute,
  } as any)
const MainAdminEmailSendConfigChannelRoute =
  MainAdminEmailSendConfigChannelRouteImport.update({
    id: '/send-config/channel',
    path: '/send-config/channel',
    getParentRoute: () => MainAdminEmailRouteRoute,
  } as any)
const MainUserAppAppIdSubAppRequestRoute =
  MainUserAppAppIdSubAppRequestRouteImport.update({
    id: '/sub-app/request',
    path: '/sub-app/request',
    getParentRoute: () => MainUserAppAppIdRouteRoute,
  } as any)
const MainUserAppAppIdSubAppListRoute =
  MainUserAppAppIdSubAppListRouteImport.update({
    id: '/sub-app/list',
    path: '/sub-app/list',
    getParentRoute: () => MainUserAppAppIdRouteRoute,
  } as any)
const MainUserAppAppIdServiceSubAppOauthServerRoute =
  MainUserAppAppIdServiceSubAppOauthServerRouteImport.update({
    id: '/service/sub-app-oauth-server',
    path: '/service/sub-app-oauth-server',
    getParentRoute: () => MainUserAppAppIdRouteRoute,
  } as any)
const MainUserAppAppIdServiceSubAppRoute =
  MainUserAppAppIdServiceSubAppRouteImport.update({
    id: '/service/sub-app',
    path: '/service/sub-app',
    getParentRoute: () => MainUserAppAppIdRouteRoute,
  } as any)
const MainUserAppAppIdServiceOauthClientRoute =
  MainUserAppAppIdServiceOauthClientRouteImport.update({
    id: '/service/oauth-client',
    path: '/service/oauth-client',
    getParentRoute: () => MainUserAppAppIdRouteRoute,
  } as any)
const MainUserAppAppIdServiceFeatureRoute =
  MainUserAppAppIdServiceFeatureRouteImport.update({
    id: '/service/feature',
    path: '/service/feature',
    getParentRoute: () => MainUserAppAppIdRouteRoute,
  } as any)
const MainUserAppAppIdServiceExterLoginRoute =
  MainUserAppAppIdServiceExterLoginRouteImport.update({
    id: '/service/exter-login',
    path: '/service/exter-login',
    getParentRoute: () => MainUserAppAppIdRouteRoute,
  } as any)
const MainUserAppAppIdFeaturesSmsTplConfigRoute =
  MainUserAppAppIdFeaturesSmsTplConfigRouteImport.update({
    id: '/features-sms/tpl-config',
    path: '/features-sms/tpl-config',
    getParentRoute: () => MainUserAppAppIdRouteRoute,
  } as any)
const MainUserAppAppIdFeaturesSmsSendRoute =
  MainUserAppAppIdFeaturesSmsSendRouteImport.update({
    id: '/features-sms/send',
    path: '/features-sms/send',
    getParentRoute: () => MainUserAppAppIdRouteRoute,
  } as any)
const MainUserAppAppIdFeaturesSmsListRoute =
  MainUserAppAppIdFeaturesSmsListRouteImport.update({
    id: '/features-sms/list',
    path: '/features-sms/list',
    getParentRoute: () => MainUserAppAppIdRouteRoute,
  } as any)
const MainUserAppAppIdFeaturesSmsConfigRoute =
  MainUserAppAppIdFeaturesSmsConfigRouteImport.update({
    id: '/features-sms/config',
    path: '/features-sms/config',
    getParentRoute: () => MainUserAppAppIdRouteRoute,
  } as any)
const MainUserAppAppIdFeaturesRbacRoleRoute =
  MainUserAppAppIdFeaturesRbacRoleRouteImport.update({
    id: '/features-rbac/role',
    path: '/features-rbac/role',
    getParentRoute: () => MainUserAppAppIdRouteRoute,
  } as any)
const MainUserAppAppIdFeaturesRbacResourceRoute =
  MainUserAppAppIdFeaturesRbacResourceRouteImport.update({
    id: '/features-rbac/resource',
    path: '/features-rbac/resource',
    getParentRoute: () => MainUserAppAppIdRouteRoute,
  } as any)
const MainUserAppAppIdFeaturesRbacAuditRoute =
  MainUserAppAppIdFeaturesRbacAuditRouteImport.update({
    id: '/features-rbac/audit',
    path: '/features-rbac/audit',
    getParentRoute: () => MainUserAppAppIdRouteRoute,
  } as any)
const MainUserAppAppIdFeaturesMailTplConfigRoute =
  MainUserAppAppIdFeaturesMailTplConfigRouteImport.update({
    id: '/features-mail/tpl-config',
    path: '/features-mail/tpl-config',
    getParentRoute: () => MainUserAppAppIdRouteRoute,
  } as any)
const MainUserAppAppIdFeaturesMailTplRoute =
  MainUserAppAppIdFeaturesMailTplRouteImport.update({
    id: '/features-mail/tpl',
    path: '/features-mail/tpl',
    getParentRoute: () => MainUserAppAppIdRouteRoute,
  } as any)
const MainUserAppAppIdFeaturesMailSendRoute =
  MainUserAppAppIdFeaturesMailSendRouteImport.update({
    id: '/features-mail/send',
    path: '/features-mail/send',
    getParentRoute: () => MainUserAppAppIdRouteRoute,
  } as any)
const MainUserAppAppIdFeaturesMailListRoute =
  MainUserAppAppIdFeaturesMailListRouteImport.update({
    id: '/features-mail/list',
    path: '/features-mail/list',
    getParentRoute: () => MainUserAppAppIdRouteRoute,
  } as any)
const MainUserAppAppIdFeaturesMailConfigRoute =
  MainUserAppAppIdFeaturesMailConfigRouteImport.update({
    id: '/features-mail/config',
    path: '/features-mail/config',
    getParentRoute: () => MainUserAppAppIdRouteRoute,
  } as any)
const MainUserAppAppIdFeaturesFileListRoute =
  MainUserAppAppIdFeaturesFileListRouteImport.update({
    id: '/features-file/list',
    path: '/features-file/list',
    getParentRoute: () => MainUserAppAppIdRouteRoute,
  } as any)
const MainUserAppAppIdFeaturesFileCollectorRoute =
  MainUserAppAppIdFeaturesFileCollectorRouteImport.update({
    id: '/features-file/collector',
    path: '/features-file/collector',
    getParentRoute: () => MainUserAppAppIdRouteRoute,
  } as any)
const MainUserAppAppIdFeaturesBarcodeListParseRoute =
  MainUserAppAppIdFeaturesBarcodeListParseRouteImport.update({
    id: '/features-barcode/list-parse',
    path: '/features-barcode/list-parse',
    getParentRoute: () => MainUserAppAppIdRouteRoute,
  } as any)
const MainUserAppAppIdFeaturesBarcodeListCreateRoute =
  MainUserAppAppIdFeaturesBarcodeListCreateRouteImport.update({
    id: '/features-barcode/list-create',
    path: '/features-barcode/list-create',
    getParentRoute: () => MainUserAppAppIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof rootIndexRoute
  '/find-password': typeof AuthFindPasswordRouteRouteWithChildren
  '/sign-in': typeof AuthSignInRouteRouteWithChildren
  '/sign-up': typeof AuthSignUpRouteRouteWithChildren
  '/admin': typeof MainAdminRouteRouteWithChildren
  '/user': typeof MainUserRouteRouteWithChildren
  '/switch-user': typeof MainSwitchUserRoute
  '/admin/app': typeof MainAdminAppRouteRouteWithChildren
  '/admin/config': typeof MainAdminConfigRouteRouteWithChildren
  '/admin/email': typeof MainAdminEmailRouteRouteWithChildren
  '/admin/file': typeof MainAdminFileRouteRouteWithChildren
  '/admin/rbac': typeof MainAdminRbacRouteRouteWithChildren
  '/admin/sms': typeof MainAdminSmsRouteRouteWithChildren
  '/admin/user': typeof MainAdminUserRouteRouteWithChildren
  '/user/account': typeof MainUserAccountRouteRouteWithChildren
  '/oauth': typeof AuthOauthOauthRoute
  '/oauth-qrcode': typeof AuthOauthOauthQrcodeRoute
  '/find-password/mail': typeof AuthFindPasswordMailRoute
  '/find-password/sms': typeof AuthFindPasswordSmsRoute
  '/sign-in/app': typeof AuthSignInAppRoute
  '/sign-in/mail': typeof AuthSignInMailRoute
  '/sign-in/mfa': typeof AuthSignInMfaRoute
  '/sign-in/sms': typeof AuthSignInSmsRoute
  '/sign-up/mail': typeof AuthSignUpMailRoute
  '/sign-up/sms': typeof AuthSignUpSmsRoute
  '/sign-in/': typeof AuthSignInIndexRoute
  '/admin/': typeof MainAdminIndexRoute
  '/user/': typeof MainUserIndexRoute
  '/user/app/$appId': typeof MainUserAppAppIdRouteRouteWithChildren
  '/user/app': typeof MainUserAppRootRouteRouteWithChildren
  '/admin/app/list': typeof MainAdminAppListRoute
  '/admin/app/request': typeof MainAdminAppRequestRoute
  '/admin/email/adapter-config': typeof MainAdminEmailAdapterConfigRoute
  '/admin/email/send-log': typeof MainAdminEmailSendLogRoute
  '/admin/file/list': typeof MainAdminFileListRoute
  '/admin/file/oss-config': typeof MainAdminFileOssConfigRoute
  '/admin/file/runtime-setting': typeof MainAdminFileRuntimeSettingRoute
  '/admin/rbac/audit-log': typeof MainAdminRbacAuditLogRoute
  '/admin/rbac/resource': typeof MainAdminRbacResourceRoute
  '/admin/rbac/role': typeof MainAdminRbacRoleRoute
  '/admin/sms/adapter-config': typeof MainAdminSmsAdapterConfigRoute
  '/admin/sms/send-log': typeof MainAdminSmsSendLogRoute
  '/admin/user/change-log': typeof MainAdminUserChangeLogRoute
  '/admin/user/login-log': typeof MainAdminUserLoginLogRoute
  '/admin/user/search': typeof MainAdminUserSearchRoute
  '/user/account/address': typeof MainUserAccountAddressRoute
  '/user/account/change-password': typeof MainUserAccountChangePasswordRoute
  '/user/account/email': typeof MainUserAccountEmailRoute
  '/user/account/external': typeof MainUserAccountExternalRoute
  '/user/account/file': typeof MainUserAccountFileRoute
  '/user/account/login-log': typeof MainUserAccountLoginLogRoute
  '/user/account/mfa': typeof MainUserAccountMfaRoute
  '/user/account/mobile': typeof MainUserAccountMobileRoute
  '/user/account/set-info': typeof MainUserAccountSetInfoRoute
  '/user/account/set-name': typeof MainUserAccountSetNameRoute
  '/admin/config/': typeof MainAdminConfigIndexRoute
  '/admin/email/send-config/channel': typeof MainAdminEmailSendConfigChannelRoute
  '/admin/email/send-config/rule': typeof MainAdminEmailSendConfigRuleRoute
  '/admin/email/send-config/template': typeof MainAdminEmailSendConfigTemplateRoute
  '/admin/sms/send-config/channel': typeof MainAdminSmsSendConfigChannelRoute
  '/admin/sms/send-config/rule': typeof MainAdminSmsSendConfigRuleRoute
  '/user/app/$appId/notify': typeof MainUserAppAppIdNotifyRoute
  '/user/app/$appId/request': typeof MainUserAppAppIdRequestRoute
  '/user/app/$appId/request-prompt': typeof MainUserAppAppIdRequestPromptRoute
  '/user/app/$appId/setting': typeof MainUserAppAppIdSettingRoute
  '/user/app/create': typeof MainUserAppRootCreateRoute
  '/user/app/dashboard': typeof MainUserAppRootDashboardRoute
  '/user/app/list': typeof MainUserAppRootListRoute
  '/user/app/$appId/': typeof MainUserAppAppIdIndexRoute
  '/user/app/$appId/features-barcode/list-create': typeof MainUserAppAppIdFeaturesBarcodeListCreateRoute
  '/user/app/$appId/features-barcode/list-parse': typeof MainUserAppAppIdFeaturesBarcodeListParseRoute
  '/user/app/$appId/features-file/collector': typeof MainUserAppAppIdFeaturesFileCollectorRoute
  '/user/app/$appId/features-file/list': typeof MainUserAppAppIdFeaturesFileListRoute
  '/user/app/$appId/features-mail/config': typeof MainUserAppAppIdFeaturesMailConfigRoute
  '/user/app/$appId/features-mail/list': typeof MainUserAppAppIdFeaturesMailListRoute
  '/user/app/$appId/features-mail/send': typeof MainUserAppAppIdFeaturesMailSendRoute
  '/user/app/$appId/features-mail/tpl': typeof MainUserAppAppIdFeaturesMailTplRoute
  '/user/app/$appId/features-mail/tpl-config': typeof MainUserAppAppIdFeaturesMailTplConfigRoute
  '/user/app/$appId/features-rbac/audit': typeof MainUserAppAppIdFeaturesRbacAuditRoute
  '/user/app/$appId/features-rbac/resource': typeof MainUserAppAppIdFeaturesRbacResourceRoute
  '/user/app/$appId/features-rbac/role': typeof MainUserAppAppIdFeaturesRbacRoleRoute
  '/user/app/$appId/features-sms/config': typeof MainUserAppAppIdFeaturesSmsConfigRoute
  '/user/app/$appId/features-sms/list': typeof MainUserAppAppIdFeaturesSmsListRoute
  '/user/app/$appId/features-sms/send': typeof MainUserAppAppIdFeaturesSmsSendRoute
  '/user/app/$appId/features-sms/tpl-config': typeof MainUserAppAppIdFeaturesSmsTplConfigRoute
  '/user/app/$appId/service/exter-login': typeof MainUserAppAppIdServiceExterLoginRoute
  '/user/app/$appId/service/feature': typeof MainUserAppAppIdServiceFeatureRoute
  '/user/app/$appId/service/oauth-client': typeof MainUserAppAppIdServiceOauthClientRoute
  '/user/app/$appId/service/sub-app': typeof MainUserAppAppIdServiceSubAppRoute
  '/user/app/$appId/service/sub-app-oauth-server': typeof MainUserAppAppIdServiceSubAppOauthServerRoute
  '/user/app/$appId/sub-app/list': typeof MainUserAppAppIdSubAppListRoute
  '/user/app/$appId/sub-app/request': typeof MainUserAppAppIdSubAppRequestRoute
}
export interface FileRoutesByTo {
  '/': typeof rootIndexRoute
  '/find-password': typeof AuthFindPasswordRouteRouteWithChildren
  '/sign-up': typeof AuthSignUpRouteRouteWithChildren
  '/switch-user': typeof MainSwitchUserRoute
  '/admin/app': typeof MainAdminAppRouteRouteWithChildren
  '/admin/email': typeof MainAdminEmailRouteRouteWithChildren
  '/admin/file': typeof MainAdminFileRouteRouteWithChildren
  '/admin/rbac': typeof MainAdminRbacRouteRouteWithChildren
  '/admin/sms': typeof MainAdminSmsRouteRouteWithChildren
  '/admin/user': typeof MainAdminUserRouteRouteWithChildren
  '/user/account': typeof MainUserAccountRouteRouteWithChildren
  '/oauth': typeof AuthOauthOauthRoute
  '/oauth-qrcode': typeof AuthOauthOauthQrcodeRoute
  '/find-password/mail': typeof AuthFindPasswordMailRoute
  '/find-password/sms': typeof AuthFindPasswordSmsRoute
  '/sign-in/app': typeof AuthSignInAppRoute
  '/sign-in/mail': typeof AuthSignInMailRoute
  '/sign-in/mfa': typeof AuthSignInMfaRoute
  '/sign-in/sms': typeof AuthSignInSmsRoute
  '/sign-up/mail': typeof AuthSignUpMailRoute
  '/sign-up/sms': typeof AuthSignUpSmsRoute
  '/sign-in': typeof AuthSignInIndexRoute
  '/admin': typeof MainAdminIndexRoute
  '/user': typeof MainUserIndexRoute
  '/user/app': typeof MainUserAppRootRouteRouteWithChildren
  '/admin/app/list': typeof MainAdminAppListRoute
  '/admin/app/request': typeof MainAdminAppRequestRoute
  '/admin/email/adapter-config': typeof MainAdminEmailAdapterConfigRoute
  '/admin/email/send-log': typeof MainAdminEmailSendLogRoute
  '/admin/file/list': typeof MainAdminFileListRoute
  '/admin/file/oss-config': typeof MainAdminFileOssConfigRoute
  '/admin/file/runtime-setting': typeof MainAdminFileRuntimeSettingRoute
  '/admin/rbac/audit-log': typeof MainAdminRbacAuditLogRoute
  '/admin/rbac/resource': typeof MainAdminRbacResourceRoute
  '/admin/rbac/role': typeof MainAdminRbacRoleRoute
  '/admin/sms/adapter-config': typeof MainAdminSmsAdapterConfigRoute
  '/admin/sms/send-log': typeof MainAdminSmsSendLogRoute
  '/admin/user/change-log': typeof MainAdminUserChangeLogRoute
  '/admin/user/login-log': typeof MainAdminUserLoginLogRoute
  '/admin/user/search': typeof MainAdminUserSearchRoute
  '/user/account/address': typeof MainUserAccountAddressRoute
  '/user/account/change-password': typeof MainUserAccountChangePasswordRoute
  '/user/account/email': typeof MainUserAccountEmailRoute
  '/user/account/external': typeof MainUserAccountExternalRoute
  '/user/account/file': typeof MainUserAccountFileRoute
  '/user/account/login-log': typeof MainUserAccountLoginLogRoute
  '/user/account/mfa': typeof MainUserAccountMfaRoute
  '/user/account/mobile': typeof MainUserAccountMobileRoute
  '/user/account/set-info': typeof MainUserAccountSetInfoRoute
  '/user/account/set-name': typeof MainUserAccountSetNameRoute
  '/admin/config': typeof MainAdminConfigIndexRoute
  '/admin/email/send-config/channel': typeof MainAdminEmailSendConfigChannelRoute
  '/admin/email/send-config/rule': typeof MainAdminEmailSendConfigRuleRoute
  '/admin/email/send-config/template': typeof MainAdminEmailSendConfigTemplateRoute
  '/admin/sms/send-config/channel': typeof MainAdminSmsSendConfigChannelRoute
  '/admin/sms/send-config/rule': typeof MainAdminSmsSendConfigRuleRoute
  '/user/app/$appId/notify': typeof MainUserAppAppIdNotifyRoute
  '/user/app/$appId/request': typeof MainUserAppAppIdRequestRoute
  '/user/app/$appId/request-prompt': typeof MainUserAppAppIdRequestPromptRoute
  '/user/app/$appId/setting': typeof MainUserAppAppIdSettingRoute
  '/user/app/create': typeof MainUserAppRootCreateRoute
  '/user/app/dashboard': typeof MainUserAppRootDashboardRoute
  '/user/app/list': typeof MainUserAppRootListRoute
  '/user/app/$appId': typeof MainUserAppAppIdIndexRoute
  '/user/app/$appId/features-barcode/list-create': typeof MainUserAppAppIdFeaturesBarcodeListCreateRoute
  '/user/app/$appId/features-barcode/list-parse': typeof MainUserAppAppIdFeaturesBarcodeListParseRoute
  '/user/app/$appId/features-file/collector': typeof MainUserAppAppIdFeaturesFileCollectorRoute
  '/user/app/$appId/features-file/list': typeof MainUserAppAppIdFeaturesFileListRoute
  '/user/app/$appId/features-mail/config': typeof MainUserAppAppIdFeaturesMailConfigRoute
  '/user/app/$appId/features-mail/list': typeof MainUserAppAppIdFeaturesMailListRoute
  '/user/app/$appId/features-mail/send': typeof MainUserAppAppIdFeaturesMailSendRoute
  '/user/app/$appId/features-mail/tpl': typeof MainUserAppAppIdFeaturesMailTplRoute
  '/user/app/$appId/features-mail/tpl-config': typeof MainUserAppAppIdFeaturesMailTplConfigRoute
  '/user/app/$appId/features-rbac/audit': typeof MainUserAppAppIdFeaturesRbacAuditRoute
  '/user/app/$appId/features-rbac/resource': typeof MainUserAppAppIdFeaturesRbacResourceRoute
  '/user/app/$appId/features-rbac/role': typeof MainUserAppAppIdFeaturesRbacRoleRoute
  '/user/app/$appId/features-sms/config': typeof MainUserAppAppIdFeaturesSmsConfigRoute
  '/user/app/$appId/features-sms/list': typeof MainUserAppAppIdFeaturesSmsListRoute
  '/user/app/$appId/features-sms/send': typeof MainUserAppAppIdFeaturesSmsSendRoute
  '/user/app/$appId/features-sms/tpl-config': typeof MainUserAppAppIdFeaturesSmsTplConfigRoute
  '/user/app/$appId/service/exter-login': typeof MainUserAppAppIdServiceExterLoginRoute
  '/user/app/$appId/service/feature': typeof MainUserAppAppIdServiceFeatureRoute
  '/user/app/$appId/service/oauth-client': typeof MainUserAppAppIdServiceOauthClientRoute
  '/user/app/$appId/service/sub-app': typeof MainUserAppAppIdServiceSubAppRoute
  '/user/app/$appId/service/sub-app-oauth-server': typeof MainUserAppAppIdServiceSubAppOauthServerRoute
  '/user/app/$appId/sub-app/list': typeof MainUserAppAppIdSubAppListRoute
  '/user/app/$appId/sub-app/request': typeof MainUserAppAppIdSubAppRequestRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteRouteWithChildren
  '/_main': typeof MainRouteRouteWithChildren
  '/_auth/find-password': typeof AuthFindPasswordRouteRouteWithChildren
  '/_auth/sign-in': typeof AuthSignInRouteRouteWithChildren
  '/_auth/sign-up': typeof AuthSignUpRouteRouteWithChildren
  '/_main/admin': typeof MainAdminRouteRouteWithChildren
  '/_main/user': typeof MainUserRouteRouteWithChildren
  '/_main/switch-user': typeof MainSwitchUserRoute
  '/(root)/': typeof rootIndexRoute
  '/_main/admin/app': typeof MainAdminAppRouteRouteWithChildren
  '/_main/admin/config': typeof MainAdminConfigRouteRouteWithChildren
  '/_main/admin/email': typeof MainAdminEmailRouteRouteWithChildren
  '/_main/admin/file': typeof MainAdminFileRouteRouteWithChildren
  '/_main/admin/rbac': typeof MainAdminRbacRouteRouteWithChildren
  '/_main/admin/sms': typeof MainAdminSmsRouteRouteWithChildren
  '/_main/admin/user': typeof MainAdminUserRouteRouteWithChildren
  '/_main/user/account': typeof MainUserAccountRouteRouteWithChildren
  '/_auth/_oauth/oauth': typeof AuthOauthOauthRoute
  '/_auth/_oauth/oauth-qrcode': typeof AuthOauthOauthQrcodeRoute
  '/_auth/find-password/mail': typeof AuthFindPasswordMailRoute
  '/_auth/find-password/sms': typeof AuthFindPasswordSmsRoute
  '/_auth/sign-in/app': typeof AuthSignInAppRoute
  '/_auth/sign-in/mail': typeof AuthSignInMailRoute
  '/_auth/sign-in/mfa': typeof AuthSignInMfaRoute
  '/_auth/sign-in/sms': typeof AuthSignInSmsRoute
  '/_auth/sign-up/mail': typeof AuthSignUpMailRoute
  '/_auth/sign-up/sms': typeof AuthSignUpSmsRoute
  '/_auth/sign-in/': typeof AuthSignInIndexRoute
  '/_main/admin/': typeof MainAdminIndexRoute
  '/_main/user/': typeof MainUserIndexRoute
  '/_main/user/app/$appId': typeof MainUserAppAppIdRouteRouteWithChildren
  '/_main/user/app/_root': typeof MainUserAppRootRouteRouteWithChildren
  '/_main/admin/app/list': typeof MainAdminAppListRoute
  '/_main/admin/app/request': typeof MainAdminAppRequestRoute
  '/_main/admin/email/adapter-config': typeof MainAdminEmailAdapterConfigRoute
  '/_main/admin/email/send-log': typeof MainAdminEmailSendLogRoute
  '/_main/admin/file/list': typeof MainAdminFileListRoute
  '/_main/admin/file/oss-config': typeof MainAdminFileOssConfigRoute
  '/_main/admin/file/runtime-setting': typeof MainAdminFileRuntimeSettingRoute
  '/_main/admin/rbac/audit-log': typeof MainAdminRbacAuditLogRoute
  '/_main/admin/rbac/resource': typeof MainAdminRbacResourceRoute
  '/_main/admin/rbac/role': typeof MainAdminRbacRoleRoute
  '/_main/admin/sms/adapter-config': typeof MainAdminSmsAdapterConfigRoute
  '/_main/admin/sms/send-log': typeof MainAdminSmsSendLogRoute
  '/_main/admin/user/change-log': typeof MainAdminUserChangeLogRoute
  '/_main/admin/user/login-log': typeof MainAdminUserLoginLogRoute
  '/_main/admin/user/search': typeof MainAdminUserSearchRoute
  '/_main/user/account/address': typeof MainUserAccountAddressRoute
  '/_main/user/account/change-password': typeof MainUserAccountChangePasswordRoute
  '/_main/user/account/email': typeof MainUserAccountEmailRoute
  '/_main/user/account/external': typeof MainUserAccountExternalRoute
  '/_main/user/account/file': typeof MainUserAccountFileRoute
  '/_main/user/account/login-log': typeof MainUserAccountLoginLogRoute
  '/_main/user/account/mfa': typeof MainUserAccountMfaRoute
  '/_main/user/account/mobile': typeof MainUserAccountMobileRoute
  '/_main/user/account/set-info': typeof MainUserAccountSetInfoRoute
  '/_main/user/account/set-name': typeof MainUserAccountSetNameRoute
  '/_main/admin/config/': typeof MainAdminConfigIndexRoute
  '/_main/admin/email/send-config/channel': typeof MainAdminEmailSendConfigChannelRoute
  '/_main/admin/email/send-config/rule': typeof MainAdminEmailSendConfigRuleRoute
  '/_main/admin/email/send-config/template': typeof MainAdminEmailSendConfigTemplateRoute
  '/_main/admin/sms/send-config/channel': typeof MainAdminSmsSendConfigChannelRoute
  '/_main/admin/sms/send-config/rule': typeof MainAdminSmsSendConfigRuleRoute
  '/_main/user/app/$appId/notify': typeof MainUserAppAppIdNotifyRoute
  '/_main/user/app/$appId/request': typeof MainUserAppAppIdRequestRoute
  '/_main/user/app/$appId/request-prompt': typeof MainUserAppAppIdRequestPromptRoute
  '/_main/user/app/$appId/setting': typeof MainUserAppAppIdSettingRoute
  '/_main/user/app/_root/create': typeof MainUserAppRootCreateRoute
  '/_main/user/app/_root/dashboard': typeof MainUserAppRootDashboardRoute
  '/_main/user/app/_root/list': typeof MainUserAppRootListRoute
  '/_main/user/app/$appId/': typeof MainUserAppAppIdIndexRoute
  '/_main/user/app/$appId/features-barcode/list-create': typeof MainUserAppAppIdFeaturesBarcodeListCreateRoute
  '/_main/user/app/$appId/features-barcode/list-parse': typeof MainUserAppAppIdFeaturesBarcodeListParseRoute
  '/_main/user/app/$appId/features-file/collector': typeof MainUserAppAppIdFeaturesFileCollectorRoute
  '/_main/user/app/$appId/features-file/list': typeof MainUserAppAppIdFeaturesFileListRoute
  '/_main/user/app/$appId/features-mail/config': typeof MainUserAppAppIdFeaturesMailConfigRoute
  '/_main/user/app/$appId/features-mail/list': typeof MainUserAppAppIdFeaturesMailListRoute
  '/_main/user/app/$appId/features-mail/send': typeof MainUserAppAppIdFeaturesMailSendRoute
  '/_main/user/app/$appId/features-mail/tpl': typeof MainUserAppAppIdFeaturesMailTplRoute
  '/_main/user/app/$appId/features-mail/tpl-config': typeof MainUserAppAppIdFeaturesMailTplConfigRoute
  '/_main/user/app/$appId/features-rbac/audit': typeof MainUserAppAppIdFeaturesRbacAuditRoute
  '/_main/user/app/$appId/features-rbac/resource': typeof MainUserAppAppIdFeaturesRbacResourceRoute
  '/_main/user/app/$appId/features-rbac/role': typeof MainUserAppAppIdFeaturesRbacRoleRoute
  '/_main/user/app/$appId/features-sms/config': typeof MainUserAppAppIdFeaturesSmsConfigRoute
  '/_main/user/app/$appId/features-sms/list': typeof MainUserAppAppIdFeaturesSmsListRoute
  '/_main/user/app/$appId/features-sms/send': typeof MainUserAppAppIdFeaturesSmsSendRoute
  '/_main/user/app/$appId/features-sms/tpl-config': typeof MainUserAppAppIdFeaturesSmsTplConfigRoute
  '/_main/user/app/$appId/service/exter-login': typeof MainUserAppAppIdServiceExterLoginRoute
  '/_main/user/app/$appId/service/feature': typeof MainUserAppAppIdServiceFeatureRoute
  '/_main/user/app/$appId/service/oauth-client': typeof MainUserAppAppIdServiceOauthClientRoute
  '/_main/user/app/$appId/service/sub-app': typeof MainUserAppAppIdServiceSubAppRoute
  '/_main/user/app/$appId/service/sub-app-oauth-server': typeof MainUserAppAppIdServiceSubAppOauthServerRoute
  '/_main/user/app/$appId/sub-app/list': typeof MainUserAppAppIdSubAppListRoute
  '/_main/user/app/$appId/sub-app/request': typeof MainUserAppAppIdSubAppRequestRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/find-password'
    | '/sign-in'
    | '/sign-up'
    | '/admin'
    | '/user'
    | '/switch-user'
    | '/admin/app'
    | '/admin/config'
    | '/admin/email'
    | '/admin/file'
    | '/admin/rbac'
    | '/admin/sms'
    | '/admin/user'
    | '/user/account'
    | '/oauth'
    | '/oauth-qrcode'
    | '/find-password/mail'
    | '/find-password/sms'
    | '/sign-in/app'
    | '/sign-in/mail'
    | '/sign-in/mfa'
    | '/sign-in/sms'
    | '/sign-up/mail'
    | '/sign-up/sms'
    | '/sign-in/'
    | '/admin/'
    | '/user/'
    | '/user/app/$appId'
    | '/user/app'
    | '/admin/app/list'
    | '/admin/app/request'
    | '/admin/email/adapter-config'
    | '/admin/email/send-log'
    | '/admin/file/list'
    | '/admin/file/oss-config'
    | '/admin/file/runtime-setting'
    | '/admin/rbac/audit-log'
    | '/admin/rbac/resource'
    | '/admin/rbac/role'
    | '/admin/sms/adapter-config'
    | '/admin/sms/send-log'
    | '/admin/user/change-log'
    | '/admin/user/login-log'
    | '/admin/user/search'
    | '/user/account/address'
    | '/user/account/change-password'
    | '/user/account/email'
    | '/user/account/external'
    | '/user/account/file'
    | '/user/account/login-log'
    | '/user/account/mfa'
    | '/user/account/mobile'
    | '/user/account/set-info'
    | '/user/account/set-name'
    | '/admin/config/'
    | '/admin/email/send-config/channel'
    | '/admin/email/send-config/rule'
    | '/admin/email/send-config/template'
    | '/admin/sms/send-config/channel'
    | '/admin/sms/send-config/rule'
    | '/user/app/$appId/notify'
    | '/user/app/$appId/request'
    | '/user/app/$appId/request-prompt'
    | '/user/app/$appId/setting'
    | '/user/app/create'
    | '/user/app/dashboard'
    | '/user/app/list'
    | '/user/app/$appId/'
    | '/user/app/$appId/features-barcode/list-create'
    | '/user/app/$appId/features-barcode/list-parse'
    | '/user/app/$appId/features-file/collector'
    | '/user/app/$appId/features-file/list'
    | '/user/app/$appId/features-mail/config'
    | '/user/app/$appId/features-mail/list'
    | '/user/app/$appId/features-mail/send'
    | '/user/app/$appId/features-mail/tpl'
    | '/user/app/$appId/features-mail/tpl-config'
    | '/user/app/$appId/features-rbac/audit'
    | '/user/app/$appId/features-rbac/resource'
    | '/user/app/$appId/features-rbac/role'
    | '/user/app/$appId/features-sms/config'
    | '/user/app/$appId/features-sms/list'
    | '/user/app/$appId/features-sms/send'
    | '/user/app/$appId/features-sms/tpl-config'
    | '/user/app/$appId/service/exter-login'
    | '/user/app/$appId/service/feature'
    | '/user/app/$appId/service/oauth-client'
    | '/user/app/$appId/service/sub-app'
    | '/user/app/$appId/service/sub-app-oauth-server'
    | '/user/app/$appId/sub-app/list'
    | '/user/app/$appId/sub-app/request'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/find-password'
    | '/sign-up'
    | '/switch-user'
    | '/admin/app'
    | '/admin/email'
    | '/admin/file'
    | '/admin/rbac'
    | '/admin/sms'
    | '/admin/user'
    | '/user/account'
    | '/oauth'
    | '/oauth-qrcode'
    | '/find-password/mail'
    | '/find-password/sms'
    | '/sign-in/app'
    | '/sign-in/mail'
    | '/sign-in/mfa'
    | '/sign-in/sms'
    | '/sign-up/mail'
    | '/sign-up/sms'
    | '/sign-in'
    | '/admin'
    | '/user'
    | '/user/app'
    | '/admin/app/list'
    | '/admin/app/request'
    | '/admin/email/adapter-config'
    | '/admin/email/send-log'
    | '/admin/file/list'
    | '/admin/file/oss-config'
    | '/admin/file/runtime-setting'
    | '/admin/rbac/audit-log'
    | '/admin/rbac/resource'
    | '/admin/rbac/role'
    | '/admin/sms/adapter-config'
    | '/admin/sms/send-log'
    | '/admin/user/change-log'
    | '/admin/user/login-log'
    | '/admin/user/search'
    | '/user/account/address'
    | '/user/account/change-password'
    | '/user/account/email'
    | '/user/account/external'
    | '/user/account/file'
    | '/user/account/login-log'
    | '/user/account/mfa'
    | '/user/account/mobile'
    | '/user/account/set-info'
    | '/user/account/set-name'
    | '/admin/config'
    | '/admin/email/send-config/channel'
    | '/admin/email/send-config/rule'
    | '/admin/email/send-config/template'
    | '/admin/sms/send-config/channel'
    | '/admin/sms/send-config/rule'
    | '/user/app/$appId/notify'
    | '/user/app/$appId/request'
    | '/user/app/$appId/request-prompt'
    | '/user/app/$appId/setting'
    | '/user/app/create'
    | '/user/app/dashboard'
    | '/user/app/list'
    | '/user/app/$appId'
    | '/user/app/$appId/features-barcode/list-create'
    | '/user/app/$appId/features-barcode/list-parse'
    | '/user/app/$appId/features-file/collector'
    | '/user/app/$appId/features-file/list'
    | '/user/app/$appId/features-mail/config'
    | '/user/app/$appId/features-mail/list'
    | '/user/app/$appId/features-mail/send'
    | '/user/app/$appId/features-mail/tpl'
    | '/user/app/$appId/features-mail/tpl-config'
    | '/user/app/$appId/features-rbac/audit'
    | '/user/app/$appId/features-rbac/resource'
    | '/user/app/$appId/features-rbac/role'
    | '/user/app/$appId/features-sms/config'
    | '/user/app/$appId/features-sms/list'
    | '/user/app/$appId/features-sms/send'
    | '/user/app/$appId/features-sms/tpl-config'
    | '/user/app/$appId/service/exter-login'
    | '/user/app/$appId/service/feature'
    | '/user/app/$appId/service/oauth-client'
    | '/user/app/$appId/service/sub-app'
    | '/user/app/$appId/service/sub-app-oauth-server'
    | '/user/app/$appId/sub-app/list'
    | '/user/app/$appId/sub-app/request'
  id:
    | '__root__'
    | '/_auth'
    | '/_main'
    | '/_auth/find-password'
    | '/_auth/sign-in'
    | '/_auth/sign-up'
    | '/_main/admin'
    | '/_main/user'
    | '/_main/switch-user'
    | '/(root)/'
    | '/_main/admin/app'
    | '/_main/admin/config'
    | '/_main/admin/email'
    | '/_main/admin/file'
    | '/_main/admin/rbac'
    | '/_main/admin/sms'
    | '/_main/admin/user'
    | '/_main/user/account'
    | '/_auth/_oauth/oauth'
    | '/_auth/_oauth/oauth-qrcode'
    | '/_auth/find-password/mail'
    | '/_auth/find-password/sms'
    | '/_auth/sign-in/app'
    | '/_auth/sign-in/mail'
    | '/_auth/sign-in/mfa'
    | '/_auth/sign-in/sms'
    | '/_auth/sign-up/mail'
    | '/_auth/sign-up/sms'
    | '/_auth/sign-in/'
    | '/_main/admin/'
    | '/_main/user/'
    | '/_main/user/app/$appId'
    | '/_main/user/app/_root'
    | '/_main/admin/app/list'
    | '/_main/admin/app/request'
    | '/_main/admin/email/adapter-config'
    | '/_main/admin/email/send-log'
    | '/_main/admin/file/list'
    | '/_main/admin/file/oss-config'
    | '/_main/admin/file/runtime-setting'
    | '/_main/admin/rbac/audit-log'
    | '/_main/admin/rbac/resource'
    | '/_main/admin/rbac/role'
    | '/_main/admin/sms/adapter-config'
    | '/_main/admin/sms/send-log'
    | '/_main/admin/user/change-log'
    | '/_main/admin/user/login-log'
    | '/_main/admin/user/search'
    | '/_main/user/account/address'
    | '/_main/user/account/change-password'
    | '/_main/user/account/email'
    | '/_main/user/account/external'
    | '/_main/user/account/file'
    | '/_main/user/account/login-log'
    | '/_main/user/account/mfa'
    | '/_main/user/account/mobile'
    | '/_main/user/account/set-info'
    | '/_main/user/account/set-name'
    | '/_main/admin/config/'
    | '/_main/admin/email/send-config/channel'
    | '/_main/admin/email/send-config/rule'
    | '/_main/admin/email/send-config/template'
    | '/_main/admin/sms/send-config/channel'
    | '/_main/admin/sms/send-config/rule'
    | '/_main/user/app/$appId/notify'
    | '/_main/user/app/$appId/request'
    | '/_main/user/app/$appId/request-prompt'
    | '/_main/user/app/$appId/setting'
    | '/_main/user/app/_root/create'
    | '/_main/user/app/_root/dashboard'
    | '/_main/user/app/_root/list'
    | '/_main/user/app/$appId/'
    | '/_main/user/app/$appId/features-barcode/list-create'
    | '/_main/user/app/$appId/features-barcode/list-parse'
    | '/_main/user/app/$appId/features-file/collector'
    | '/_main/user/app/$appId/features-file/list'
    | '/_main/user/app/$appId/features-mail/config'
    | '/_main/user/app/$appId/features-mail/list'
    | '/_main/user/app/$appId/features-mail/send'
    | '/_main/user/app/$appId/features-mail/tpl'
    | '/_main/user/app/$appId/features-mail/tpl-config'
    | '/_main/user/app/$appId/features-rbac/audit'
    | '/_main/user/app/$appId/features-rbac/resource'
    | '/_main/user/app/$appId/features-rbac/role'
    | '/_main/user/app/$appId/features-sms/config'
    | '/_main/user/app/$appId/features-sms/list'
    | '/_main/user/app/$appId/features-sms/send'
    | '/_main/user/app/$appId/features-sms/tpl-config'
    | '/_main/user/app/$appId/service/exter-login'
    | '/_main/user/app/$appId/service/feature'
    | '/_main/user/app/$appId/service/oauth-client'
    | '/_main/user/app/$appId/service/sub-app'
    | '/_main/user/app/$appId/service/sub-app-oauth-server'
    | '/_main/user/app/$appId/sub-app/list'
    | '/_main/user/app/$appId/sub-app/request'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  MainRouteRoute: typeof MainRouteRouteWithChildren
  rootIndexRoute: typeof rootIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_main': {
      id: '/_main'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof MainRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(root)/': {
      id: '/(root)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof rootIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_main/switch-user': {
      id: '/_main/switch-user'
      path: '/switch-user'
      fullPath: '/switch-user'
      preLoaderRoute: typeof MainSwitchUserRouteImport
      parentRoute: typeof MainRouteRoute
    }
    '/_main/user': {
      id: '/_main/user'
      path: '/user'
      fullPath: '/user'
      preLoaderRoute: typeof MainUserRouteRouteImport
      parentRoute: typeof MainRouteRoute
    }
    '/_main/admin': {
      id: '/_main/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof MainAdminRouteRouteImport
      parentRoute: typeof MainRouteRoute
    }
    '/_auth/sign-up': {
      id: '/_auth/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/find-password': {
      id: '/_auth/find-password'
      path: '/find-password'
      fullPath: '/find-password'
      preLoaderRoute: typeof AuthFindPasswordRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_main/user/': {
      id: '/_main/user/'
      path: '/'
      fullPath: '/user/'
      preLoaderRoute: typeof MainUserIndexRouteImport
      parentRoute: typeof MainUserRouteRoute
    }
    '/_main/admin/': {
      id: '/_main/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof MainAdminIndexRouteImport
      parentRoute: typeof MainAdminRouteRoute
    }
    '/_auth/sign-in/': {
      id: '/_auth/sign-in/'
      path: '/'
      fullPath: '/sign-in/'
      preLoaderRoute: typeof AuthSignInIndexRouteImport
      parentRoute: typeof AuthSignInRouteRoute
    }
    '/_auth/sign-up/sms': {
      id: '/_auth/sign-up/sms'
      path: '/sms'
      fullPath: '/sign-up/sms'
      preLoaderRoute: typeof AuthSignUpSmsRouteImport
      parentRoute: typeof AuthSignUpRouteRoute
    }
    '/_auth/sign-up/mail': {
      id: '/_auth/sign-up/mail'
      path: '/mail'
      fullPath: '/sign-up/mail'
      preLoaderRoute: typeof AuthSignUpMailRouteImport
      parentRoute: typeof AuthSignUpRouteRoute
    }
    '/_auth/sign-in/sms': {
      id: '/_auth/sign-in/sms'
      path: '/sms'
      fullPath: '/sign-in/sms'
      preLoaderRoute: typeof AuthSignInSmsRouteImport
      parentRoute: typeof AuthSignInRouteRoute
    }
    '/_auth/sign-in/mfa': {
      id: '/_auth/sign-in/mfa'
      path: '/mfa'
      fullPath: '/sign-in/mfa'
      preLoaderRoute: typeof AuthSignInMfaRouteImport
      parentRoute: typeof AuthSignInRouteRoute
    }
    '/_auth/sign-in/mail': {
      id: '/_auth/sign-in/mail'
      path: '/mail'
      fullPath: '/sign-in/mail'
      preLoaderRoute: typeof AuthSignInMailRouteImport
      parentRoute: typeof AuthSignInRouteRoute
    }
    '/_auth/sign-in/app': {
      id: '/_auth/sign-in/app'
      path: '/app'
      fullPath: '/sign-in/app'
      preLoaderRoute: typeof AuthSignInAppRouteImport
      parentRoute: typeof AuthSignInRouteRoute
    }
    '/_auth/find-password/sms': {
      id: '/_auth/find-password/sms'
      path: '/sms'
      fullPath: '/find-password/sms'
      preLoaderRoute: typeof AuthFindPasswordSmsRouteImport
      parentRoute: typeof AuthFindPasswordRouteRoute
    }
    '/_auth/find-password/mail': {
      id: '/_auth/find-password/mail'
      path: '/mail'
      fullPath: '/find-password/mail'
      preLoaderRoute: typeof AuthFindPasswordMailRouteImport
      parentRoute: typeof AuthFindPasswordRouteRoute
    }
    '/_auth/_oauth/oauth-qrcode': {
      id: '/_auth/_oauth/oauth-qrcode'
      path: '/oauth-qrcode'
      fullPath: '/oauth-qrcode'
      preLoaderRoute: typeof AuthOauthOauthQrcodeRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/_oauth/oauth': {
      id: '/_auth/_oauth/oauth'
      path: '/oauth'
      fullPath: '/oauth'
      preLoaderRoute: typeof AuthOauthOauthRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_main/user/account': {
      id: '/_main/user/account'
      path: '/account'
      fullPath: '/user/account'
      preLoaderRoute: typeof MainUserAccountRouteRouteImport
      parentRoute: typeof MainUserRouteRoute
    }
    '/_main/admin/user': {
      id: '/_main/admin/user'
      path: '/user'
      fullPath: '/admin/user'
      preLoaderRoute: typeof MainAdminUserRouteRouteImport
      parentRoute: typeof MainAdminRouteRoute
    }
    '/_main/admin/sms': {
      id: '/_main/admin/sms'
      path: '/sms'
      fullPath: '/admin/sms'
      preLoaderRoute: typeof MainAdminSmsRouteRouteImport
      parentRoute: typeof MainAdminRouteRoute
    }
    '/_main/admin/rbac': {
      id: '/_main/admin/rbac'
      path: '/rbac'
      fullPath: '/admin/rbac'
      preLoaderRoute: typeof MainAdminRbacRouteRouteImport
      parentRoute: typeof MainAdminRouteRoute
    }
    '/_main/admin/file': {
      id: '/_main/admin/file'
      path: '/file'
      fullPath: '/admin/file'
      preLoaderRoute: typeof MainAdminFileRouteRouteImport
      parentRoute: typeof MainAdminRouteRoute
    }
    '/_main/admin/email': {
      id: '/_main/admin/email'
      path: '/email'
      fullPath: '/admin/email'
      preLoaderRoute: typeof MainAdminEmailRouteRouteImport
      parentRoute: typeof MainAdminRouteRoute
    }
    '/_main/admin/config': {
      id: '/_main/admin/config'
      path: '/config'
      fullPath: '/admin/config'
      preLoaderRoute: typeof MainAdminConfigRouteRouteImport
      parentRoute: typeof MainAdminRouteRoute
    }
    '/_main/admin/app': {
      id: '/_main/admin/app'
      path: '/app'
      fullPath: '/admin/app'
      preLoaderRoute: typeof MainAdminAppRouteRouteImport
      parentRoute: typeof MainAdminRouteRoute
    }
    '/_main/admin/config/': {
      id: '/_main/admin/config/'
      path: '/'
      fullPath: '/admin/config/'
      preLoaderRoute: typeof MainAdminConfigIndexRouteImport
      parentRoute: typeof MainAdminConfigRouteRoute
    }
    '/_main/user/account/set-name': {
      id: '/_main/user/account/set-name'
      path: '/set-name'
      fullPath: '/user/account/set-name'
      preLoaderRoute: typeof MainUserAccountSetNameRouteImport
      parentRoute: typeof MainUserAccountRouteRoute
    }
    '/_main/user/account/set-info': {
      id: '/_main/user/account/set-info'
      path: '/set-info'
      fullPath: '/user/account/set-info'
      preLoaderRoute: typeof MainUserAccountSetInfoRouteImport
      parentRoute: typeof MainUserAccountRouteRoute
    }
    '/_main/user/account/mobile': {
      id: '/_main/user/account/mobile'
      path: '/mobile'
      fullPath: '/user/account/mobile'
      preLoaderRoute: typeof MainUserAccountMobileRouteImport
      parentRoute: typeof MainUserAccountRouteRoute
    }
    '/_main/user/account/mfa': {
      id: '/_main/user/account/mfa'
      path: '/mfa'
      fullPath: '/user/account/mfa'
      preLoaderRoute: typeof MainUserAccountMfaRouteImport
      parentRoute: typeof MainUserAccountRouteRoute
    }
    '/_main/user/account/login-log': {
      id: '/_main/user/account/login-log'
      path: '/login-log'
      fullPath: '/user/account/login-log'
      preLoaderRoute: typeof MainUserAccountLoginLogRouteImport
      parentRoute: typeof MainUserAccountRouteRoute
    }
    '/_main/user/account/file': {
      id: '/_main/user/account/file'
      path: '/file'
      fullPath: '/user/account/file'
      preLoaderRoute: typeof MainUserAccountFileRouteImport
      parentRoute: typeof MainUserAccountRouteRoute
    }
    '/_main/user/account/external': {
      id: '/_main/user/account/external'
      path: '/external'
      fullPath: '/user/account/external'
      preLoaderRoute: typeof MainUserAccountExternalRouteImport
      parentRoute: typeof MainUserAccountRouteRoute
    }
    '/_main/user/account/email': {
      id: '/_main/user/account/email'
      path: '/email'
      fullPath: '/user/account/email'
      preLoaderRoute: typeof MainUserAccountEmailRouteImport
      parentRoute: typeof MainUserAccountRouteRoute
    }
    '/_main/user/account/change-password': {
      id: '/_main/user/account/change-password'
      path: '/change-password'
      fullPath: '/user/account/change-password'
      preLoaderRoute: typeof MainUserAccountChangePasswordRouteImport
      parentRoute: typeof MainUserAccountRouteRoute
    }
    '/_main/user/account/address': {
      id: '/_main/user/account/address'
      path: '/address'
      fullPath: '/user/account/address'
      preLoaderRoute: typeof MainUserAccountAddressRouteImport
      parentRoute: typeof MainUserAccountRouteRoute
    }
    '/_main/admin/user/search': {
      id: '/_main/admin/user/search'
      path: '/search'
      fullPath: '/admin/user/search'
      preLoaderRoute: typeof MainAdminUserSearchRouteImport
      parentRoute: typeof MainAdminUserRouteRoute
    }
    '/_main/admin/user/login-log': {
      id: '/_main/admin/user/login-log'
      path: '/login-log'
      fullPath: '/admin/user/login-log'
      preLoaderRoute: typeof MainAdminUserLoginLogRouteImport
      parentRoute: typeof MainAdminUserRouteRoute
    }
    '/_main/admin/user/change-log': {
      id: '/_main/admin/user/change-log'
      path: '/change-log'
      fullPath: '/admin/user/change-log'
      preLoaderRoute: typeof MainAdminUserChangeLogRouteImport
      parentRoute: typeof MainAdminUserRouteRoute
    }
    '/_main/admin/sms/send-log': {
      id: '/_main/admin/sms/send-log'
      path: '/send-log'
      fullPath: '/admin/sms/send-log'
      preLoaderRoute: typeof MainAdminSmsSendLogRouteImport
      parentRoute: typeof MainAdminSmsRouteRoute
    }
    '/_main/admin/sms/adapter-config': {
      id: '/_main/admin/sms/adapter-config'
      path: '/adapter-config'
      fullPath: '/admin/sms/adapter-config'
      preLoaderRoute: typeof MainAdminSmsAdapterConfigRouteImport
      parentRoute: typeof MainAdminSmsRouteRoute
    }
    '/_main/admin/rbac/role': {
      id: '/_main/admin/rbac/role'
      path: '/role'
      fullPath: '/admin/rbac/role'
      preLoaderRoute: typeof MainAdminRbacRoleRouteImport
      parentRoute: typeof MainAdminRbacRouteRoute
    }
    '/_main/admin/rbac/resource': {
      id: '/_main/admin/rbac/resource'
      path: '/resource'
      fullPath: '/admin/rbac/resource'
      preLoaderRoute: typeof MainAdminRbacResourceRouteImport
      parentRoute: typeof MainAdminRbacRouteRoute
    }
    '/_main/admin/rbac/audit-log': {
      id: '/_main/admin/rbac/audit-log'
      path: '/audit-log'
      fullPath: '/admin/rbac/audit-log'
      preLoaderRoute: typeof MainAdminRbacAuditLogRouteImport
      parentRoute: typeof MainAdminRbacRouteRoute
    }
    '/_main/admin/file/runtime-setting': {
      id: '/_main/admin/file/runtime-setting'
      path: '/runtime-setting'
      fullPath: '/admin/file/runtime-setting'
      preLoaderRoute: typeof MainAdminFileRuntimeSettingRouteImport
      parentRoute: typeof MainAdminFileRouteRoute
    }
    '/_main/admin/file/oss-config': {
      id: '/_main/admin/file/oss-config'
      path: '/oss-config'
      fullPath: '/admin/file/oss-config'
      preLoaderRoute: typeof MainAdminFileOssConfigRouteImport
      parentRoute: typeof MainAdminFileRouteRoute
    }
    '/_main/admin/file/list': {
      id: '/_main/admin/file/list'
      path: '/list'
      fullPath: '/admin/file/list'
      preLoaderRoute: typeof MainAdminFileListRouteImport
      parentRoute: typeof MainAdminFileRouteRoute
    }
    '/_main/admin/email/send-log': {
      id: '/_main/admin/email/send-log'
      path: '/send-log'
      fullPath: '/admin/email/send-log'
      preLoaderRoute: typeof MainAdminEmailSendLogRouteImport
      parentRoute: typeof MainAdminEmailRouteRoute
    }
    '/_main/admin/email/adapter-config': {
      id: '/_main/admin/email/adapter-config'
      path: '/adapter-config'
      fullPath: '/admin/email/adapter-config'
      preLoaderRoute: typeof MainAdminEmailAdapterConfigRouteImport
      parentRoute: typeof MainAdminEmailRouteRoute
    }
    '/_main/admin/app/request': {
      id: '/_main/admin/app/request'
      path: '/request'
      fullPath: '/admin/app/request'
      preLoaderRoute: typeof MainAdminAppRequestRouteImport
      parentRoute: typeof MainAdminAppRouteRoute
    }
    '/_main/admin/app/list': {
      id: '/_main/admin/app/list'
      path: '/list'
      fullPath: '/admin/app/list'
      preLoaderRoute: typeof MainAdminAppListRouteImport
      parentRoute: typeof MainAdminAppRouteRoute
    }
    '/_main/user/app/_root': {
      id: '/_main/user/app/_root'
      path: '/app'
      fullPath: '/user/app'
      preLoaderRoute: typeof MainUserAppRootRouteRouteImport
      parentRoute: typeof MainUserRouteRoute
    }
    '/_main/user/app/$appId': {
      id: '/_main/user/app/$appId'
      path: '/app/$appId'
      fullPath: '/user/app/$appId'
      preLoaderRoute: typeof MainUserAppAppIdRouteRouteImport
      parentRoute: typeof MainUserRouteRoute
    }
    '/_main/user/app/$appId/': {
      id: '/_main/user/app/$appId/'
      path: '/'
      fullPath: '/user/app/$appId/'
      preLoaderRoute: typeof MainUserAppAppIdIndexRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
    '/_main/user/app/_root/list': {
      id: '/_main/user/app/_root/list'
      path: '/list'
      fullPath: '/user/app/list'
      preLoaderRoute: typeof MainUserAppRootListRouteImport
      parentRoute: typeof MainUserAppRootRouteRoute
    }
    '/_main/user/app/_root/dashboard': {
      id: '/_main/user/app/_root/dashboard'
      path: '/dashboard'
      fullPath: '/user/app/dashboard'
      preLoaderRoute: typeof MainUserAppRootDashboardRouteImport
      parentRoute: typeof MainUserAppRootRouteRoute
    }
    '/_main/user/app/_root/create': {
      id: '/_main/user/app/_root/create'
      path: '/create'
      fullPath: '/user/app/create'
      preLoaderRoute: typeof MainUserAppRootCreateRouteImport
      parentRoute: typeof MainUserAppRootRouteRoute
    }
    '/_main/user/app/$appId/setting': {
      id: '/_main/user/app/$appId/setting'
      path: '/setting'
      fullPath: '/user/app/$appId/setting'
      preLoaderRoute: typeof MainUserAppAppIdSettingRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
    '/_main/user/app/$appId/request-prompt': {
      id: '/_main/user/app/$appId/request-prompt'
      path: '/request-prompt'
      fullPath: '/user/app/$appId/request-prompt'
      preLoaderRoute: typeof MainUserAppAppIdRequestPromptRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
    '/_main/user/app/$appId/request': {
      id: '/_main/user/app/$appId/request'
      path: '/request'
      fullPath: '/user/app/$appId/request'
      preLoaderRoute: typeof MainUserAppAppIdRequestRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
    '/_main/user/app/$appId/notify': {
      id: '/_main/user/app/$appId/notify'
      path: '/notify'
      fullPath: '/user/app/$appId/notify'
      preLoaderRoute: typeof MainUserAppAppIdNotifyRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
    '/_main/admin/sms/send-config/rule': {
      id: '/_main/admin/sms/send-config/rule'
      path: '/send-config/rule'
      fullPath: '/admin/sms/send-config/rule'
      preLoaderRoute: typeof MainAdminSmsSendConfigRuleRouteImport
      parentRoute: typeof MainAdminSmsRouteRoute
    }
    '/_main/admin/sms/send-config/channel': {
      id: '/_main/admin/sms/send-config/channel'
      path: '/send-config/channel'
      fullPath: '/admin/sms/send-config/channel'
      preLoaderRoute: typeof MainAdminSmsSendConfigChannelRouteImport
      parentRoute: typeof MainAdminSmsRouteRoute
    }
    '/_main/admin/email/send-config/template': {
      id: '/_main/admin/email/send-config/template'
      path: '/send-config/template'
      fullPath: '/admin/email/send-config/template'
      preLoaderRoute: typeof MainAdminEmailSendConfigTemplateRouteImport
      parentRoute: typeof MainAdminEmailRouteRoute
    }
    '/_main/admin/email/send-config/rule': {
      id: '/_main/admin/email/send-config/rule'
      path: '/send-config/rule'
      fullPath: '/admin/email/send-config/rule'
      preLoaderRoute: typeof MainAdminEmailSendConfigRuleRouteImport
      parentRoute: typeof MainAdminEmailRouteRoute
    }
    '/_main/admin/email/send-config/channel': {
      id: '/_main/admin/email/send-config/channel'
      path: '/send-config/channel'
      fullPath: '/admin/email/send-config/channel'
      preLoaderRoute: typeof MainAdminEmailSendConfigChannelRouteImport
      parentRoute: typeof MainAdminEmailRouteRoute
    }
    '/_main/user/app/$appId/sub-app/request': {
      id: '/_main/user/app/$appId/sub-app/request'
      path: '/sub-app/request'
      fullPath: '/user/app/$appId/sub-app/request'
      preLoaderRoute: typeof MainUserAppAppIdSubAppRequestRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
    '/_main/user/app/$appId/sub-app/list': {
      id: '/_main/user/app/$appId/sub-app/list'
      path: '/sub-app/list'
      fullPath: '/user/app/$appId/sub-app/list'
      preLoaderRoute: typeof MainUserAppAppIdSubAppListRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
    '/_main/user/app/$appId/service/sub-app-oauth-server': {
      id: '/_main/user/app/$appId/service/sub-app-oauth-server'
      path: '/service/sub-app-oauth-server'
      fullPath: '/user/app/$appId/service/sub-app-oauth-server'
      preLoaderRoute: typeof MainUserAppAppIdServiceSubAppOauthServerRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
    '/_main/user/app/$appId/service/sub-app': {
      id: '/_main/user/app/$appId/service/sub-app'
      path: '/service/sub-app'
      fullPath: '/user/app/$appId/service/sub-app'
      preLoaderRoute: typeof MainUserAppAppIdServiceSubAppRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
    '/_main/user/app/$appId/service/oauth-client': {
      id: '/_main/user/app/$appId/service/oauth-client'
      path: '/service/oauth-client'
      fullPath: '/user/app/$appId/service/oauth-client'
      preLoaderRoute: typeof MainUserAppAppIdServiceOauthClientRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
    '/_main/user/app/$appId/service/feature': {
      id: '/_main/user/app/$appId/service/feature'
      path: '/service/feature'
      fullPath: '/user/app/$appId/service/feature'
      preLoaderRoute: typeof MainUserAppAppIdServiceFeatureRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
    '/_main/user/app/$appId/service/exter-login': {
      id: '/_main/user/app/$appId/service/exter-login'
      path: '/service/exter-login'
      fullPath: '/user/app/$appId/service/exter-login'
      preLoaderRoute: typeof MainUserAppAppIdServiceExterLoginRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
    '/_main/user/app/$appId/features-sms/tpl-config': {
      id: '/_main/user/app/$appId/features-sms/tpl-config'
      path: '/features-sms/tpl-config'
      fullPath: '/user/app/$appId/features-sms/tpl-config'
      preLoaderRoute: typeof MainUserAppAppIdFeaturesSmsTplConfigRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
    '/_main/user/app/$appId/features-sms/send': {
      id: '/_main/user/app/$appId/features-sms/send'
      path: '/features-sms/send'
      fullPath: '/user/app/$appId/features-sms/send'
      preLoaderRoute: typeof MainUserAppAppIdFeaturesSmsSendRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
    '/_main/user/app/$appId/features-sms/list': {
      id: '/_main/user/app/$appId/features-sms/list'
      path: '/features-sms/list'
      fullPath: '/user/app/$appId/features-sms/list'
      preLoaderRoute: typeof MainUserAppAppIdFeaturesSmsListRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
    '/_main/user/app/$appId/features-sms/config': {
      id: '/_main/user/app/$appId/features-sms/config'
      path: '/features-sms/config'
      fullPath: '/user/app/$appId/features-sms/config'
      preLoaderRoute: typeof MainUserAppAppIdFeaturesSmsConfigRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
    '/_main/user/app/$appId/features-rbac/role': {
      id: '/_main/user/app/$appId/features-rbac/role'
      path: '/features-rbac/role'
      fullPath: '/user/app/$appId/features-rbac/role'
      preLoaderRoute: typeof MainUserAppAppIdFeaturesRbacRoleRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
    '/_main/user/app/$appId/features-rbac/resource': {
      id: '/_main/user/app/$appId/features-rbac/resource'
      path: '/features-rbac/resource'
      fullPath: '/user/app/$appId/features-rbac/resource'
      preLoaderRoute: typeof MainUserAppAppIdFeaturesRbacResourceRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
    '/_main/user/app/$appId/features-rbac/audit': {
      id: '/_main/user/app/$appId/features-rbac/audit'
      path: '/features-rbac/audit'
      fullPath: '/user/app/$appId/features-rbac/audit'
      preLoaderRoute: typeof MainUserAppAppIdFeaturesRbacAuditRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
    '/_main/user/app/$appId/features-mail/tpl-config': {
      id: '/_main/user/app/$appId/features-mail/tpl-config'
      path: '/features-mail/tpl-config'
      fullPath: '/user/app/$appId/features-mail/tpl-config'
      preLoaderRoute: typeof MainUserAppAppIdFeaturesMailTplConfigRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
    '/_main/user/app/$appId/features-mail/tpl': {
      id: '/_main/user/app/$appId/features-mail/tpl'
      path: '/features-mail/tpl'
      fullPath: '/user/app/$appId/features-mail/tpl'
      preLoaderRoute: typeof MainUserAppAppIdFeaturesMailTplRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
    '/_main/user/app/$appId/features-mail/send': {
      id: '/_main/user/app/$appId/features-mail/send'
      path: '/features-mail/send'
      fullPath: '/user/app/$appId/features-mail/send'
      preLoaderRoute: typeof MainUserAppAppIdFeaturesMailSendRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
    '/_main/user/app/$appId/features-mail/list': {
      id: '/_main/user/app/$appId/features-mail/list'
      path: '/features-mail/list'
      fullPath: '/user/app/$appId/features-mail/list'
      preLoaderRoute: typeof MainUserAppAppIdFeaturesMailListRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
    '/_main/user/app/$appId/features-mail/config': {
      id: '/_main/user/app/$appId/features-mail/config'
      path: '/features-mail/config'
      fullPath: '/user/app/$appId/features-mail/config'
      preLoaderRoute: typeof MainUserAppAppIdFeaturesMailConfigRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
    '/_main/user/app/$appId/features-file/list': {
      id: '/_main/user/app/$appId/features-file/list'
      path: '/features-file/list'
      fullPath: '/user/app/$appId/features-file/list'
      preLoaderRoute: typeof MainUserAppAppIdFeaturesFileListRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
    '/_main/user/app/$appId/features-file/collector': {
      id: '/_main/user/app/$appId/features-file/collector'
      path: '/features-file/collector'
      fullPath: '/user/app/$appId/features-file/collector'
      preLoaderRoute: typeof MainUserAppAppIdFeaturesFileCollectorRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
    '/_main/user/app/$appId/features-barcode/list-parse': {
      id: '/_main/user/app/$appId/features-barcode/list-parse'
      path: '/features-barcode/list-parse'
      fullPath: '/user/app/$appId/features-barcode/list-parse'
      preLoaderRoute: typeof MainUserAppAppIdFeaturesBarcodeListParseRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
    '/_main/user/app/$appId/features-barcode/list-create': {
      id: '/_main/user/app/$appId/features-barcode/list-create'
      path: '/features-barcode/list-create'
      fullPath: '/user/app/$appId/features-barcode/list-create'
      preLoaderRoute: typeof MainUserAppAppIdFeaturesBarcodeListCreateRouteImport
      parentRoute: typeof MainUserAppAppIdRouteRoute
    }
  }
}

interface AuthFindPasswordRouteRouteChildren {
  AuthFindPasswordMailRoute: typeof AuthFindPasswordMailRoute
  AuthFindPasswordSmsRoute: typeof AuthFindPasswordSmsRoute
}

const AuthFindPasswordRouteRouteChildren: AuthFindPasswordRouteRouteChildren = {
  AuthFindPasswordMailRoute: AuthFindPasswordMailRoute,
  AuthFindPasswordSmsRoute: AuthFindPasswordSmsRoute,
}

const AuthFindPasswordRouteRouteWithChildren =
  AuthFindPasswordRouteRoute._addFileChildren(
    AuthFindPasswordRouteRouteChildren,
  )

interface AuthSignInRouteRouteChildren {
  AuthSignInAppRoute: typeof AuthSignInAppRoute
  AuthSignInMailRoute: typeof AuthSignInMailRoute
  AuthSignInMfaRoute: typeof AuthSignInMfaRoute
  AuthSignInSmsRoute: typeof AuthSignInSmsRoute
  AuthSignInIndexRoute: typeof AuthSignInIndexRoute
}

const AuthSignInRouteRouteChildren: AuthSignInRouteRouteChildren = {
  AuthSignInAppRoute: AuthSignInAppRoute,
  AuthSignInMailRoute: AuthSignInMailRoute,
  AuthSignInMfaRoute: AuthSignInMfaRoute,
  AuthSignInSmsRoute: AuthSignInSmsRoute,
  AuthSignInIndexRoute: AuthSignInIndexRoute,
}

const AuthSignInRouteRouteWithChildren = AuthSignInRouteRoute._addFileChildren(
  AuthSignInRouteRouteChildren,
)

interface AuthSignUpRouteRouteChildren {
  AuthSignUpMailRoute: typeof AuthSignUpMailRoute
  AuthSignUpSmsRoute: typeof AuthSignUpSmsRoute
}

const AuthSignUpRouteRouteChildren: AuthSignUpRouteRouteChildren = {
  AuthSignUpMailRoute: AuthSignUpMailRoute,
  AuthSignUpSmsRoute: AuthSignUpSmsRoute,
}

const AuthSignUpRouteRouteWithChildren = AuthSignUpRouteRoute._addFileChildren(
  AuthSignUpRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthFindPasswordRouteRoute: typeof AuthFindPasswordRouteRouteWithChildren
  AuthSignInRouteRoute: typeof AuthSignInRouteRouteWithChildren
  AuthSignUpRouteRoute: typeof AuthSignUpRouteRouteWithChildren
  AuthOauthOauthRoute: typeof AuthOauthOauthRoute
  AuthOauthOauthQrcodeRoute: typeof AuthOauthOauthQrcodeRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthFindPasswordRouteRoute: AuthFindPasswordRouteRouteWithChildren,
  AuthSignInRouteRoute: AuthSignInRouteRouteWithChildren,
  AuthSignUpRouteRoute: AuthSignUpRouteRouteWithChildren,
  AuthOauthOauthRoute: AuthOauthOauthRoute,
  AuthOauthOauthQrcodeRoute: AuthOauthOauthQrcodeRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface MainAdminAppRouteRouteChildren {
  MainAdminAppListRoute: typeof MainAdminAppListRoute
  MainAdminAppRequestRoute: typeof MainAdminAppRequestRoute
}

const MainAdminAppRouteRouteChildren: MainAdminAppRouteRouteChildren = {
  MainAdminAppListRoute: MainAdminAppListRoute,
  MainAdminAppRequestRoute: MainAdminAppRequestRoute,
}

const MainAdminAppRouteRouteWithChildren =
  MainAdminAppRouteRoute._addFileChildren(MainAdminAppRouteRouteChildren)

interface MainAdminConfigRouteRouteChildren {
  MainAdminConfigIndexRoute: typeof MainAdminConfigIndexRoute
}

const MainAdminConfigRouteRouteChildren: MainAdminConfigRouteRouteChildren = {
  MainAdminConfigIndexRoute: MainAdminConfigIndexRoute,
}

const MainAdminConfigRouteRouteWithChildren =
  MainAdminConfigRouteRoute._addFileChildren(MainAdminConfigRouteRouteChildren)

interface MainAdminEmailRouteRouteChildren {
  MainAdminEmailAdapterConfigRoute: typeof MainAdminEmailAdapterConfigRoute
  MainAdminEmailSendLogRoute: typeof MainAdminEmailSendLogRoute
  MainAdminEmailSendConfigChannelRoute: typeof MainAdminEmailSendConfigChannelRoute
  MainAdminEmailSendConfigRuleRoute: typeof MainAdminEmailSendConfigRuleRoute
  MainAdminEmailSendConfigTemplateRoute: typeof MainAdminEmailSendConfigTemplateRoute
}

const MainAdminEmailRouteRouteChildren: MainAdminEmailRouteRouteChildren = {
  MainAdminEmailAdapterConfigRoute: MainAdminEmailAdapterConfigRoute,
  MainAdminEmailSendLogRoute: MainAdminEmailSendLogRoute,
  MainAdminEmailSendConfigChannelRoute: MainAdminEmailSendConfigChannelRoute,
  MainAdminEmailSendConfigRuleRoute: MainAdminEmailSendConfigRuleRoute,
  MainAdminEmailSendConfigTemplateRoute: MainAdminEmailSendConfigTemplateRoute,
}

const MainAdminEmailRouteRouteWithChildren =
  MainAdminEmailRouteRoute._addFileChildren(MainAdminEmailRouteRouteChildren)

interface MainAdminFileRouteRouteChildren {
  MainAdminFileListRoute: typeof MainAdminFileListRoute
  MainAdminFileOssConfigRoute: typeof MainAdminFileOssConfigRoute
  MainAdminFileRuntimeSettingRoute: typeof MainAdminFileRuntimeSettingRoute
}

const MainAdminFileRouteRouteChildren: MainAdminFileRouteRouteChildren = {
  MainAdminFileListRoute: MainAdminFileListRoute,
  MainAdminFileOssConfigRoute: MainAdminFileOssConfigRoute,
  MainAdminFileRuntimeSettingRoute: MainAdminFileRuntimeSettingRoute,
}

const MainAdminFileRouteRouteWithChildren =
  MainAdminFileRouteRoute._addFileChildren(MainAdminFileRouteRouteChildren)

interface MainAdminRbacRouteRouteChildren {
  MainAdminRbacAuditLogRoute: typeof MainAdminRbacAuditLogRoute
  MainAdminRbacResourceRoute: typeof MainAdminRbacResourceRoute
  MainAdminRbacRoleRoute: typeof MainAdminRbacRoleRoute
}

const MainAdminRbacRouteRouteChildren: MainAdminRbacRouteRouteChildren = {
  MainAdminRbacAuditLogRoute: MainAdminRbacAuditLogRoute,
  MainAdminRbacResourceRoute: MainAdminRbacResourceRoute,
  MainAdminRbacRoleRoute: MainAdminRbacRoleRoute,
}

const MainAdminRbacRouteRouteWithChildren =
  MainAdminRbacRouteRoute._addFileChildren(MainAdminRbacRouteRouteChildren)

interface MainAdminSmsRouteRouteChildren {
  MainAdminSmsAdapterConfigRoute: typeof MainAdminSmsAdapterConfigRoute
  MainAdminSmsSendLogRoute: typeof MainAdminSmsSendLogRoute
  MainAdminSmsSendConfigChannelRoute: typeof MainAdminSmsSendConfigChannelRoute
  MainAdminSmsSendConfigRuleRoute: typeof MainAdminSmsSendConfigRuleRoute
}

const MainAdminSmsRouteRouteChildren: MainAdminSmsRouteRouteChildren = {
  MainAdminSmsAdapterConfigRoute: MainAdminSmsAdapterConfigRoute,
  MainAdminSmsSendLogRoute: MainAdminSmsSendLogRoute,
  MainAdminSmsSendConfigChannelRoute: MainAdminSmsSendConfigChannelRoute,
  MainAdminSmsSendConfigRuleRoute: MainAdminSmsSendConfigRuleRoute,
}

const MainAdminSmsRouteRouteWithChildren =
  MainAdminSmsRouteRoute._addFileChildren(MainAdminSmsRouteRouteChildren)

interface MainAdminUserRouteRouteChildren {
  MainAdminUserChangeLogRoute: typeof MainAdminUserChangeLogRoute
  MainAdminUserLoginLogRoute: typeof MainAdminUserLoginLogRoute
  MainAdminUserSearchRoute: typeof MainAdminUserSearchRoute
}

const MainAdminUserRouteRouteChildren: MainAdminUserRouteRouteChildren = {
  MainAdminUserChangeLogRoute: MainAdminUserChangeLogRoute,
  MainAdminUserLoginLogRoute: MainAdminUserLoginLogRoute,
  MainAdminUserSearchRoute: MainAdminUserSearchRoute,
}

const MainAdminUserRouteRouteWithChildren =
  MainAdminUserRouteRoute._addFileChildren(MainAdminUserRouteRouteChildren)

interface MainAdminRouteRouteChildren {
  MainAdminAppRouteRoute: typeof MainAdminAppRouteRouteWithChildren
  MainAdminConfigRouteRoute: typeof MainAdminConfigRouteRouteWithChildren
  MainAdminEmailRouteRoute: typeof MainAdminEmailRouteRouteWithChildren
  MainAdminFileRouteRoute: typeof MainAdminFileRouteRouteWithChildren
  MainAdminRbacRouteRoute: typeof MainAdminRbacRouteRouteWithChildren
  MainAdminSmsRouteRoute: typeof MainAdminSmsRouteRouteWithChildren
  MainAdminUserRouteRoute: typeof MainAdminUserRouteRouteWithChildren
  MainAdminIndexRoute: typeof MainAdminIndexRoute
}

const MainAdminRouteRouteChildren: MainAdminRouteRouteChildren = {
  MainAdminAppRouteRoute: MainAdminAppRouteRouteWithChildren,
  MainAdminConfigRouteRoute: MainAdminConfigRouteRouteWithChildren,
  MainAdminEmailRouteRoute: MainAdminEmailRouteRouteWithChildren,
  MainAdminFileRouteRoute: MainAdminFileRouteRouteWithChildren,
  MainAdminRbacRouteRoute: MainAdminRbacRouteRouteWithChildren,
  MainAdminSmsRouteRoute: MainAdminSmsRouteRouteWithChildren,
  MainAdminUserRouteRoute: MainAdminUserRouteRouteWithChildren,
  MainAdminIndexRoute: MainAdminIndexRoute,
}

const MainAdminRouteRouteWithChildren = MainAdminRouteRoute._addFileChildren(
  MainAdminRouteRouteChildren,
)

interface MainUserAccountRouteRouteChildren {
  MainUserAccountAddressRoute: typeof MainUserAccountAddressRoute
  MainUserAccountChangePasswordRoute: typeof MainUserAccountChangePasswordRoute
  MainUserAccountEmailRoute: typeof MainUserAccountEmailRoute
  MainUserAccountExternalRoute: typeof MainUserAccountExternalRoute
  MainUserAccountFileRoute: typeof MainUserAccountFileRoute
  MainUserAccountLoginLogRoute: typeof MainUserAccountLoginLogRoute
  MainUserAccountMfaRoute: typeof MainUserAccountMfaRoute
  MainUserAccountMobileRoute: typeof MainUserAccountMobileRoute
  MainUserAccountSetInfoRoute: typeof MainUserAccountSetInfoRoute
  MainUserAccountSetNameRoute: typeof MainUserAccountSetNameRoute
}

const MainUserAccountRouteRouteChildren: MainUserAccountRouteRouteChildren = {
  MainUserAccountAddressRoute: MainUserAccountAddressRoute,
  MainUserAccountChangePasswordRoute: MainUserAccountChangePasswordRoute,
  MainUserAccountEmailRoute: MainUserAccountEmailRoute,
  MainUserAccountExternalRoute: MainUserAccountExternalRoute,
  MainUserAccountFileRoute: MainUserAccountFileRoute,
  MainUserAccountLoginLogRoute: MainUserAccountLoginLogRoute,
  MainUserAccountMfaRoute: MainUserAccountMfaRoute,
  MainUserAccountMobileRoute: MainUserAccountMobileRoute,
  MainUserAccountSetInfoRoute: MainUserAccountSetInfoRoute,
  MainUserAccountSetNameRoute: MainUserAccountSetNameRoute,
}

const MainUserAccountRouteRouteWithChildren =
  MainUserAccountRouteRoute._addFileChildren(MainUserAccountRouteRouteChildren)

interface MainUserAppAppIdRouteRouteChildren {
  MainUserAppAppIdNotifyRoute: typeof MainUserAppAppIdNotifyRoute
  MainUserAppAppIdRequestRoute: typeof MainUserAppAppIdRequestRoute
  MainUserAppAppIdRequestPromptRoute: typeof MainUserAppAppIdRequestPromptRoute
  MainUserAppAppIdSettingRoute: typeof MainUserAppAppIdSettingRoute
  MainUserAppAppIdIndexRoute: typeof MainUserAppAppIdIndexRoute
  MainUserAppAppIdFeaturesBarcodeListCreateRoute: typeof MainUserAppAppIdFeaturesBarcodeListCreateRoute
  MainUserAppAppIdFeaturesBarcodeListParseRoute: typeof MainUserAppAppIdFeaturesBarcodeListParseRoute
  MainUserAppAppIdFeaturesFileCollectorRoute: typeof MainUserAppAppIdFeaturesFileCollectorRoute
  MainUserAppAppIdFeaturesFileListRoute: typeof MainUserAppAppIdFeaturesFileListRoute
  MainUserAppAppIdFeaturesMailConfigRoute: typeof MainUserAppAppIdFeaturesMailConfigRoute
  MainUserAppAppIdFeaturesMailListRoute: typeof MainUserAppAppIdFeaturesMailListRoute
  MainUserAppAppIdFeaturesMailSendRoute: typeof MainUserAppAppIdFeaturesMailSendRoute
  MainUserAppAppIdFeaturesMailTplRoute: typeof MainUserAppAppIdFeaturesMailTplRoute
  MainUserAppAppIdFeaturesMailTplConfigRoute: typeof MainUserAppAppIdFeaturesMailTplConfigRoute
  MainUserAppAppIdFeaturesRbacAuditRoute: typeof MainUserAppAppIdFeaturesRbacAuditRoute
  MainUserAppAppIdFeaturesRbacResourceRoute: typeof MainUserAppAppIdFeaturesRbacResourceRoute
  MainUserAppAppIdFeaturesRbacRoleRoute: typeof MainUserAppAppIdFeaturesRbacRoleRoute
  MainUserAppAppIdFeaturesSmsConfigRoute: typeof MainUserAppAppIdFeaturesSmsConfigRoute
  MainUserAppAppIdFeaturesSmsListRoute: typeof MainUserAppAppIdFeaturesSmsListRoute
  MainUserAppAppIdFeaturesSmsSendRoute: typeof MainUserAppAppIdFeaturesSmsSendRoute
  MainUserAppAppIdFeaturesSmsTplConfigRoute: typeof MainUserAppAppIdFeaturesSmsTplConfigRoute
  MainUserAppAppIdServiceExterLoginRoute: typeof MainUserAppAppIdServiceExterLoginRoute
  MainUserAppAppIdServiceFeatureRoute: typeof MainUserAppAppIdServiceFeatureRoute
  MainUserAppAppIdServiceOauthClientRoute: typeof MainUserAppAppIdServiceOauthClientRoute
  MainUserAppAppIdServiceSubAppRoute: typeof MainUserAppAppIdServiceSubAppRoute
  MainUserAppAppIdServiceSubAppOauthServerRoute: typeof MainUserAppAppIdServiceSubAppOauthServerRoute
  MainUserAppAppIdSubAppListRoute: typeof MainUserAppAppIdSubAppListRoute
  MainUserAppAppIdSubAppRequestRoute: typeof MainUserAppAppIdSubAppRequestRoute
}

const MainUserAppAppIdRouteRouteChildren: MainUserAppAppIdRouteRouteChildren = {
  MainUserAppAppIdNotifyRoute: MainUserAppAppIdNotifyRoute,
  MainUserAppAppIdRequestRoute: MainUserAppAppIdRequestRoute,
  MainUserAppAppIdRequestPromptRoute: MainUserAppAppIdRequestPromptRoute,
  MainUserAppAppIdSettingRoute: MainUserAppAppIdSettingRoute,
  MainUserAppAppIdIndexRoute: MainUserAppAppIdIndexRoute,
  MainUserAppAppIdFeaturesBarcodeListCreateRoute:
    MainUserAppAppIdFeaturesBarcodeListCreateRoute,
  MainUserAppAppIdFeaturesBarcodeListParseRoute:
    MainUserAppAppIdFeaturesBarcodeListParseRoute,
  MainUserAppAppIdFeaturesFileCollectorRoute:
    MainUserAppAppIdFeaturesFileCollectorRoute,
  MainUserAppAppIdFeaturesFileListRoute: MainUserAppAppIdFeaturesFileListRoute,
  MainUserAppAppIdFeaturesMailConfigRoute:
    MainUserAppAppIdFeaturesMailConfigRoute,
  MainUserAppAppIdFeaturesMailListRoute: MainUserAppAppIdFeaturesMailListRoute,
  MainUserAppAppIdFeaturesMailSendRoute: MainUserAppAppIdFeaturesMailSendRoute,
  MainUserAppAppIdFeaturesMailTplRoute: MainUserAppAppIdFeaturesMailTplRoute,
  MainUserAppAppIdFeaturesMailTplConfigRoute:
    MainUserAppAppIdFeaturesMailTplConfigRoute,
  MainUserAppAppIdFeaturesRbacAuditRoute:
    MainUserAppAppIdFeaturesRbacAuditRoute,
  MainUserAppAppIdFeaturesRbacResourceRoute:
    MainUserAppAppIdFeaturesRbacResourceRoute,
  MainUserAppAppIdFeaturesRbacRoleRoute: MainUserAppAppIdFeaturesRbacRoleRoute,
  MainUserAppAppIdFeaturesSmsConfigRoute:
    MainUserAppAppIdFeaturesSmsConfigRoute,
  MainUserAppAppIdFeaturesSmsListRoute: MainUserAppAppIdFeaturesSmsListRoute,
  MainUserAppAppIdFeaturesSmsSendRoute: MainUserAppAppIdFeaturesSmsSendRoute,
  MainUserAppAppIdFeaturesSmsTplConfigRoute:
    MainUserAppAppIdFeaturesSmsTplConfigRoute,
  MainUserAppAppIdServiceExterLoginRoute:
    MainUserAppAppIdServiceExterLoginRoute,
  MainUserAppAppIdServiceFeatureRoute: MainUserAppAppIdServiceFeatureRoute,
  MainUserAppAppIdServiceOauthClientRoute:
    MainUserAppAppIdServiceOauthClientRoute,
  MainUserAppAppIdServiceSubAppRoute: MainUserAppAppIdServiceSubAppRoute,
  MainUserAppAppIdServiceSubAppOauthServerRoute:
    MainUserAppAppIdServiceSubAppOauthServerRoute,
  MainUserAppAppIdSubAppListRoute: MainUserAppAppIdSubAppListRoute,
  MainUserAppAppIdSubAppRequestRoute: MainUserAppAppIdSubAppRequestRoute,
}

const MainUserAppAppIdRouteRouteWithChildren =
  MainUserAppAppIdRouteRoute._addFileChildren(
    MainUserAppAppIdRouteRouteChildren,
  )

interface MainUserAppRootRouteRouteChildren {
  MainUserAppRootCreateRoute: typeof MainUserAppRootCreateRoute
  MainUserAppRootDashboardRoute: typeof MainUserAppRootDashboardRoute
  MainUserAppRootListRoute: typeof MainUserAppRootListRoute
}

const MainUserAppRootRouteRouteChildren: MainUserAppRootRouteRouteChildren = {
  MainUserAppRootCreateRoute: MainUserAppRootCreateRoute,
  MainUserAppRootDashboardRoute: MainUserAppRootDashboardRoute,
  MainUserAppRootListRoute: MainUserAppRootListRoute,
}

const MainUserAppRootRouteRouteWithChildren =
  MainUserAppRootRouteRoute._addFileChildren(MainUserAppRootRouteRouteChildren)

interface MainUserRouteRouteChildren {
  MainUserAccountRouteRoute: typeof MainUserAccountRouteRouteWithChildren
  MainUserIndexRoute: typeof MainUserIndexRoute
  MainUserAppAppIdRouteRoute: typeof MainUserAppAppIdRouteRouteWithChildren
  MainUserAppRootRouteRoute: typeof MainUserAppRootRouteRouteWithChildren
}

const MainUserRouteRouteChildren: MainUserRouteRouteChildren = {
  MainUserAccountRouteRoute: MainUserAccountRouteRouteWithChildren,
  MainUserIndexRoute: MainUserIndexRoute,
  MainUserAppAppIdRouteRoute: MainUserAppAppIdRouteRouteWithChildren,
  MainUserAppRootRouteRoute: MainUserAppRootRouteRouteWithChildren,
}

const MainUserRouteRouteWithChildren = MainUserRouteRoute._addFileChildren(
  MainUserRouteRouteChildren,
)

interface MainRouteRouteChildren {
  MainAdminRouteRoute: typeof MainAdminRouteRouteWithChildren
  MainUserRouteRoute: typeof MainUserRouteRouteWithChildren
  MainSwitchUserRoute: typeof MainSwitchUserRoute
}

const MainRouteRouteChildren: MainRouteRouteChildren = {
  MainAdminRouteRoute: MainAdminRouteRouteWithChildren,
  MainUserRouteRoute: MainUserRouteRouteWithChildren,
  MainSwitchUserRoute: MainSwitchUserRoute,
}

const MainRouteRouteWithChildren = MainRouteRoute._addFileChildren(
  MainRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthRouteRoute: AuthRouteRouteWithChildren,
  MainRouteRoute: MainRouteRouteWithChildren,
  rootIndexRoute: rootIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
